import React, { useCallback, createRef } from "react";
import Select from "react-select";
import axios from "axios";

import * as actionType from "../../../constants/actionTypes"
// import Validation from "../../Utility/Validation";
import Sidebar from "../../Constant/sidebar";
import Footer from "../../Constant/Footer";
import TopBar from "../../Constant/TopBar";
import { toast } from "react-toastify";
import * as userActions from "../../../actions/index";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import ImageCam from "./ImageCam";
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Tooltip from '@mui/material/Tooltip';
// import CropImg from "./ImgCrop/CropImg";
import Moment from "moment";
import Webcam from "react-webcam";
import { borderRadius } from "@mui/system";
import ReactCrop from 'react-easy-crop';
import Picture from "./Picture";
import AvatarImageCropper from 'react-avatar-image-cropper';
import { el } from "date-fns/locale";
import ReactDatePicker from "react-datepicker";
import { Cropper } from 'react-advanced-cropper';



import TextField from '@mui/material/TextField';
// import AdapterJalali from '@date-io/date-fns-jalali';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";
// import Validation from "../../Utility/Validation";
import Validation from "../../Utility/Validations"
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { CropImg } from './ImageCrop';
// import ReactCrop from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css';
// import EasyCrop from "./EasyCrop";
// import { createObjectURL, base64StringToBlob } from "blob-util";


const customStyles = {
    // option: (provided, state) => ({
    //     ...provided,
    //     "&:hover": {
    //         backgroundColor: state.isFocused ? "#e7f5fe" : "",
    //     },
    //     backgroundColor: state.isSelected ? "#4a8fb8" : "",
    // }),
    option: (provided, state) => ({
        ...provided,
        "&:hover": {
            backgroundColor:
                !state.isSelected && state.isFocused ? "#e7f5fe" : "",
        },
        backgroundColor: state.isSelected ? "#4a8fb8" : "",
    }),

};

const permission_info = JSON.parse(localStorage.getItem("permissions"));
const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
const school_code = user_info?.school_code === null || user_info === null ? "" : user_info?.school_code;
class AddStudent extends React.Component {
    inputRef = createRef();
    cropperRef = createRef();
    constructor(props) {

        super(props)

        window.addEventListener('keydown', this.handleKeyPress);
        this.webcamRef = React.createRef();
        this.videoRef = null;


        this.constraints = { facingMode: 'environment', "video": { width: { exact: 400 } }, advanced: [{ focusMode: "continuous" }] };
        this.imageTag = document.getElementById('image-tag');
        this.videoTag = document.getElementById('video-tag');
        this.imageCapturer = null;


        this.state = {
            school_domain: "",
            OpenImageModal: false,
            isLoading: false,
            // crop: {
            //     unit: '%',
            //     width: 30,
            //     aspect: 1 / 1,
            // },
            showEasyCrop: false,
            selectedFile: null,
            croppedImage: null,
            video: null,
            cam_Start: null,
            imageSrc: "",
            errorMessage: "",
            hiddenpassword: true,
            showTooltip: false,
            add_student_form: {
                showInput: true,
                student_first_name: {
                    type: "text",
                    label: "First Name *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },

                student_last_name: {
                    type: "text",
                    label: "Last Name",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                preferred_name: {
                    type: "text",
                    label: "Preferred Name *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },

                student_email: {
                    type: "email",
                    label: "Student E-mail address *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true, email: true },
                },

                class_id: {
                    type: "select",
                    label: "Select Year *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                    options: [],
                },

                class_name: {
                    type: "text",
                    label: "Select class *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                    options: [],
                },

                campus_name: {
                    type: "text",
                    label: "Campus",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                dormitory_id_name: {
                    type: "text",
                    label: "",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },

                dormitory_id: {
                    type: "select",
                    label: "Select Dormitory *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                    options: [],
                },

                sporting_house: {
                    type: "text",
                    label: "Sporting House",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                laundry_number: {
                    type: "text",
                    label: "Laundry Number",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                tutor_name: {
                    type: "text",
                    label: "PC or Tutor or Carer",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                tutor_email: {
                    type: "email",
                    label: "E-mail address(PC or Tutor or Carer) ",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false, email: true },
                },

                date_of_birth: {
                    type: "date",
                    label: "Date Of Birth *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },

                student_age: {
                    type: "text",
                    label: "Age",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: true },
                },

                kiosk_mode_pin: {
                    type: "number",
                    label: "Kiosk Mode PIN *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "Kiosk Mode PIN",
                    validations: { required: true, max_length: 6, number: true },
                },

                student_phone: {
                    type: "text",
                    label: "Student's Mobile Number *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },

                salutation: {
                    type: "text",
                    label: "Salutation",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent1_type: {
                    type: "select",
                    label: "Parent 1 Type *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                    options: [
                        { label: "Select Type", value: "" },
                        { label: "Father", value: "father" },
                        { label: "Mother", value: "mother" },
                        { label: "Guardian", value: "guardian" },
                        { label: "Other", value: "other" },
                    ],
                },

                parent2_type: {
                    type: "select",
                    label: "Parent 2 Type ",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                    options: [
                        { label: "Select Type", value: "" },
                        { label: "Father", value: "father" },
                        { label: "Mother", value: "mother" },
                        { label: "Guardian", value: "guardian" },
                        { label: "Other", value: "other" },
                    ],
                },
                parent1_email: {
                    type: "email",
                    label: "Parent 1 Email *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false, email: true },
                },

                parent2_email: {
                    type: "email",
                    label: "Parent 2 Email",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false, email: true },
                },

                parent1_name: {
                    type: "text",
                    label: "Parent 1 Name *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },

                parent_id: {
                    type: "hidden",
                    label: "Parent Id",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                parent2_name: {
                    type: "text",
                    label: "Parent 2  Name ",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                parent1_phone: {
                    type: "text",
                    label: "Parent 1 Mobile Number *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },

                parent2_phone: {
                    type: "text",
                    label: "Parent 2  Mobile Number",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                parent1_home_phone: {
                    type: "text",
                    label: "Home phone (parent1)",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                parent1_work_phone: {
                    type: "text",
                    label: "Work phone (parent1)",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                parent2_home_phone: {
                    type: "text",
                    label: "Home phone (parent2)",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                parent2_work_phone: {
                    type: "text",
                    label: "Work phone (parent2)",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                first_point_contact: {
                    type: "select",
                    label: "First Point of Contact (Number) *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                    options: [
                        { label: "First Point of Contact (Number)", value: "" },
                        { label: "Parent 1 Contact Number", value: "p1" },
                        { label: "Parent 2  Contact Number", value: "p2" },
                    ],
                },

                first_point_email: {
                    type: "select",
                    label: "First Point of Contact (Email) *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                    options: [
                        { label: "First Point of Contact (Email)", value: "" },
                        { label: "Parent 1 Email Address", value: "p1" },
                        { label: "Parent 2  Email Address", value: "p2" },
                    ],
                },

                primary_parent: {
                    type: "select",
                    label: "Primary Parent",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                    options: [
                        { label: "Primary Parent", value: "" },
                        { label: "Parent 1", value: "p1" },
                        { label: "Parent 2", value: "p2" },
                    ],
                },

                show_parent_detail_app: {
                    type: "checkbox",
                    label: "Show Parent Details on Liberty App",
                    value: false,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },

                exclude_automatic_host: {
                    type: "checkbox",
                    label: "Exclude as automatic Host ",
                    value: false,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },
                exclude_parent1_as_host: {
                    type: "checkbox",
                    label: "Exclude parent1 as Host ",
                    value: false,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },
                exclude_parent2_as_host: {
                    type: "checkbox",
                    label: "Exclude parent2 as Host ",
                    value: false,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },

                allergy_unauth_access: {
                    type: "checkbox",
                    label: "Allow Unauthenticated Access to student Allergy or Emergency details ",
                    value: false,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },

                withdraw_leave: {
                    type: "checkbox",
                    label: "Withdraw Ad-Hoc Leave",
                    value: false,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },

                permitted_student_app_signout: {
                    type: "checkbox",
                    label: "Permitted to Sign Out using Student App",
                    value: false,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },

                display_image_required: {
                    type: "radio",
                    label: "Want to display Image? * ",
                    value: "false",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: true },
                },

                student_allergy_status: {
                    type: "radio",
                    label: "Allergic *",
                    value: "no",
                    valid: true,
                    status: false,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: true },
                },
                school_name: {
                    type: "hidden",
                    label: "School Name *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                gender: {
                    type: "radio",
                    label: "Gender *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: true },
                },

                student_avatar: {
                    label: "File",
                    type: "file",
                    value: '',
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                    thumbnail_image: "/assets/media/school-logo.png",
                },

                school_detail_id: {
                    type: "hidden",
                    label: "",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                country_code: {
                    type: "hidden",
                    label: "country_host",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    // placeholder: "dikonia@gmail.com",
                    validations: { required: false },
                },

                data_status: {
                    type: "hidden",
                    label: "data_status",
                    value: "null",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: false },
                },
                unique_pin: {
                    type: "number",
                    label: "",
                    value: "",
                    valid: true,
                    error_msg: "Unique number must be 4 digit as per format",
                    onBlur_out: false,
                    validations: { required: true },
                },
            },

            host_data: {
                host_id: {
                    type: "hidden",
                    // label: "Host Name *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    // placeholder: "",
                    validations: { required: false },
                },
                host_name: {
                    type: "text",
                    label: "Host Name *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },
                host_relation: {
                    type: "text",
                    label: "Host's Relation *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },
                host_email: {
                    type: "email",
                    label: "Host's Email *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true, email: true },
                },
                host_contact: {
                    type: "text",
                    label: "Host's Mobile Number *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },
                host_address: {
                    type: "text",
                    label: "Host's Address *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },
                is_host_approved: {
                    type: "checkbox",
                    label: "This Host will be automatically Approved",
                    value: true,
                    valid: true,
                    error_msg: "",
                    validations: { required: false },
                },
                remark_parents: {
                    type: "text",
                    label: "Parent's remark",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                remark_boarding: {
                    type: "text",
                    label: "Boarding's remark",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                remark_host: {
                    type: "text",
                    label: "Host's remark",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                data_status: {
                    type: "hidden",
                    label: "data_status",
                    value: "null",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    validations: { required: false },
                },
                host_matched: {
                    type: "text",
                    // label: "Host Name *",
                    value: false,
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    // placeholder: "",
                    validations: { required: false },
                },
            },
            additional_hosts_data: [],

            allergy_data: [
                {
                    id: 0,
                    allergy_name: "",
                    allergy_info: ""
                }
            ],

            parent_address_data: [{
                parent_address_type: {
                    type: "text",
                    label: "",
                    value: "parent1",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: true },
                },
                address_line1: {
                    type: "text",
                    label: "Address Line 1",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                address_line2: {
                    type: "text",
                    label: "Address Line 2",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },

                parent_city: {
                    type: "text",
                    label: "City",
                    value: "",
                    valid: true,
                    options: [],
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent_state: {
                    type: "text",
                    label: "State",
                    value: "",
                    valid: true,
                    options: [],
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent_postcode: {
                    type: "text",
                    label: "Post Code ",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent_country: {
                    type: "text",
                    label: "Country *",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    country_code: "",
                    validations: { required: false },
                },

            },
            {
                address_line1: {
                    type: "text",
                    label: "Address Line 1",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                address_line2: {
                    type: "text",
                    label: "Address Line 2",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent_city: {
                    type: "text",
                    label: "City",
                    value: "",
                    valid: true,
                    options: [],
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent_state: {
                    type: "text",
                    label: "State",
                    value: "",
                    valid: true,
                    options: [],
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent_postcode: {
                    type: "text",
                    label: "Post Code ",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
                parent_country: {
                    type: "text",
                    label: "Country ",
                    value: "",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    country_code: "",
                    placeholder: "",
                    validations: { required: false },
                },
                parent_address_type: {
                    type: "text",
                    label: "Country",
                    value: "parent2",
                    valid: true,
                    error_msg: "",
                    onBlur_out: false,
                    placeholder: "",
                    validations: { required: false },
                },
            },
            ],

            parent1_as_host: {
                type: "checkbox",
                isChecked: '',
                label: "Show Parent Details on Liberty App",
                value: true,
                valid: true,
                error_msg: "",
                validations: { required: false },
            },
            parent2_as_host: {
                type: "checkbox",
                isChecked: '',
                label: "Show Parent Details on Liberty App",
                value: true,
                valid: true,
                error_msg: "",
                validations: { required: false },
            },
            student_age_show: {
                type: "text",
                label: "Age",
                value: "",
                valid: true,
                error_msg: "",
                onBlur_out: false,
                validations: { required: true },
            },
            country_id: {
                type: "select",
                label: "Country *",
                value: "",
                valid: true,
                error_msg: "",
                onBlur_out: false,
                // placeholder: "Select weekend day",
                validations: { required: true },
                options: [],
            },
            address_same_as_parent1: {
                type: "checkbox",
                isChecked: '',
                label: "Show Parent Details on Liberty App",
                value: false,
                valid: true,
                error_msg: "",
                validations: { required: false },
            },
            father_details: false,
            mother_details: false,
        };
    }

    componentDidMount() {
        this.GetAllClassesList();
        this.GetAllCountries();
        // this.GetAllSelectedCountries();

        const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
        // const startPoint = user_info.email.lastIndexOf("@")
        // const email_extansion = user_info.email.slice(startPoint, user_info.email.length);
        // this.setState({ school_domain: email_extansion })
        const email_extansion = user_info.user_school.student_domain_name.startsWith('@')
            ? user_info.user_school.student_domain_name
            : '@' + user_info.user_school.student_domain_name;

        this.setState({ school_domain: email_extansion });

        const update_add_student_form = { ...this.state.add_student_form };
        update_add_student_form['first_point_email'].value = ''; // Set value to empty string or default value

        update_add_student_form['country_code'].value = user_info.user_school.country_code;
        this.setState({ add_student_form: update_add_student_form });
    }


    GetAllClassesList = async (form_data) => {
        this.props.onGetAllClassesList().then((response) => {
            let country_level = [];
            country_level.push({
                label: "Select Year",
                value: "",
            });
            const update_add_student_form = { ...this.state.add_student_form };
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    country_level.push({
                        label: arrayData[key].class_name,
                        value: arrayData[key].class_id,
                        class_name: arrayData[key].class_name,
                        is_dummy: arrayData[key].is_dummy,
                    });
                }
            }
            update_add_student_form['class_id'].options = country_level;
            this.setState({ add_student_form: update_add_student_form });
        });
    }


    GetAllDormitoryStudent = async (dormitory_type) => {
        this.props.onGetAllDormitoryStudent(true, dormitory_type).then((response) => {
            let country_level = [];
            country_level.push({
                label: "Select Dormitory",
                value: "",
            });
            const update_add_student_form = { ...this.state.add_student_form };
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    if (arrayData[key].dormitory_status === true) {
                        country_level.push({
                            label: arrayData[key].dormitory_name,
                            value: arrayData[key].dormitory_id,
                            is_dummy: arrayData[key].is_dummy,
                        });
                    }
                }
            }
            update_add_student_form['dormitory_id'].options = country_level;
            this.setState({ add_student_form: update_add_student_form });
        });
    }



    ////////////////////////////// Parent address API's ////////////////////////
    ///////////////////////////// for country ///////////////////////

    // GetAllSelectedCountries = async (form_data) => {
    //     this.props.onGetAllSelectedCountries().then((response) => {
    //         let country_level = [];
    //         country_level.push({
    //             label: "Country",
    //             value: "",
    //         });
    //         const update_country = { ...this.state.country_id };
    //         if (response.success === true) {
    //             const arrayData = response.data.rows;
    //             for (let key in arrayData) {
    //                 country_level.push({
    //                     label: arrayData[key].name,
    //                     value: arrayData[key].country_id,
    //                     country_code: arrayData[key].country_code,
    //                 });
    //             }
    //         }
    //         update_country.options = country_level;
    //         this.setState({ country_id: update_country });
    //     });
    // }
    GetAllCountries = async (form_data) => {
        try {
            const response = await axios({
                method: "get",
                url: `${actionType.environment_url}/api/GetAllCountries`,
            });

            let country_level = [];
            country_level.push({
                label: "Country",
                value: "",
            });

            const update_country = { ...this.state.country_id };
            console.log(response, "responseresponse");

            if (response.data.success === true) {
                const arrayData = response.data.data;
                for (let key in arrayData) {
                    country_level.push({
                        label: arrayData[key].name,
                        value: arrayData[key].country_id,
                        country_code: arrayData[key].country_code,
                    });
                }
            }

            update_country.options = country_level;
            this.setState({ country_id: update_country });
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    ///////////////////////////// for state ///////////////////////

    GetAllStatesByCountryIdForFather = async (CountryID) => {
        this.props.onGetAllStatesByCountryId(CountryID).then((response) => {
            let state_level = [];
            state_level.push({
                label: "State",
                value: "",
            });
            const update_parent_address_data = this.state.parent_address_data
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    if (arrayData[key].is_activate === true) {
                        state_level.push({
                            label: arrayData[key].state_name,
                            value: arrayData[key].state_id,
                        });
                    }

                }
                update_parent_address_data[0].parent_state.options = state_level;
                this.setState({ parent_address_data: update_parent_address_data })
            }
        });
    }
    GetAllStatesByCountryIdForMother = async (CountryID) => {
        this.props.onGetAllStatesByCountryId(CountryID).then((response) => {
            let state_level = [];
            state_level.push({
                label: "State",
                value: "",
            });
            const update_parent_address_data = this.state.parent_address_data
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    if (arrayData[key].is_activate === true) {
                        state_level.push({
                            label: arrayData[key].state_name,
                            value: arrayData[key].state_id,
                        });
                    }

                }
                update_parent_address_data[1].parent_state.options = state_level;
                this.setState({ parent_address_data: update_parent_address_data })
            }
        });
    }

    ///////////////////////////// for city ///////////////////////

    GetAllCitiesByStateIdForFather = async (state_id) => {
        this.props.onGetAllCitiesByStateId(state_id).then((response) => {
            let City_level = [];
            City_level.push({
                label: "City",
                value: "",
            });
            const update_parent_address_data = this.state.parent_address_data
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    if (arrayData[key].is_activate === true) {
                        City_level.push({
                            label: arrayData[key].city_name,
                            value: arrayData[key].city_id,
                        });
                    }
                }
            }
            update_parent_address_data[0].parent_city.options = City_level;
            this.setState({ parent_address_data: update_parent_address_data })

        });
    }

    GetAllCitiesByStateIdForMother = async (state_id) => {
        this.props.onGetAllCitiesByStateId(state_id).then((response) => {
            let City_level = [];
            City_level.push({
                label: "City",
                value: "",
            });
            const update_parent_address_data = this.state.parent_address_data
            if (response.success === true) {
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    if (arrayData[key].is_activate === true) {
                        City_level.push({
                            label: arrayData[key].city_name,
                            value: arrayData[key].city_id,
                        });
                    }
                }
            }
            update_parent_address_data[1].parent_city.options = City_level;
            this.setState({ parent_address_data: update_parent_address_data })

        });
    }



    ////////////////////////////// main input change handler /////////////////////////

    inputChangeHandler(event, identifier) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };
        if (identifier === "parent1_name") {
            form_element.value = event.target.value;
            this.fahterDetailsRequire(event.target.value)
        } else if (identifier === "parent2_name") {
            form_element.value = event.target.value;
            this.mohterDetailsRequire(event.target.value)
        } else if (identifier === "kiosk_mode_pin") {
            form_element.value = event.target.value;
            // Always re-validate kiosk pin on every keystroke using the real rule
            if (!this.state.add_student_form.showInput) {
                const isExactly6 = form_element.value.length === 6;
                form_element.valid = isExactly6;
                form_element.error_msg = isExactly6 ? "" : "Kiosk pin must be exactly 6 digits.";
                form_element.onBlur_out = true; // Keep showing error/success live
            } else {
                // Auto-generate mode — always valid
                form_element.valid = true;
                form_element.error_msg = "";
                form_element.onBlur_out = false;
            }
            const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
            update_add_student_form['school_name'].value = user_info.user_school.school_name;
            update_add_student_form['school_detail_id'].value = user_info.user_school.school_detail_id;
            update_add_student_form[identifier] = form_element;
            let is_form_valid = true;
            for (let key in update_add_student_form) {
                if (key === 'showInput') continue;
                is_form_valid = update_add_student_form[key].valid && is_form_valid;
            }
            this.setState({ add_student_form: update_add_student_form, is_form_valid });
            return; // Skip the generic path below
        } else {
            form_element.value = event.target.value;
        }
        const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
        update_add_student_form['school_name'].value = user_info.user_school.school_name;
        update_add_student_form['school_detail_id'].value = user_info.user_school.school_detail_id;

        if (identifier === 'gender') {
            update_add_student_form['dormitory_id'].value = '';
            update_add_student_form['dormitory_id_name'].value = '';
            this.GetAllDormitoryStudent(event.target.value);
        }

        // Check Validation
        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;

        update_add_student_form[identifier] = form_element;
        let is_form_valid = true;
        for (let identifier in update_add_student_form) {
            is_form_valid = update_add_student_form[identifier].valid && is_form_valid;
        }
        this.setState({
            add_student_form: update_add_student_form,
            is_form_valid: is_form_valid,
        });
    }


    inputChangeHandlerParentNames(event, identifier) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };
        if (identifier === "parent1_name") {
            form_element.value = event.target.value;
            this.fahterDetailsRequire(event.target.value)
        } else if (identifier === "parent2_name") {
            form_element.value = event.target.value;
            this.mohterDetailsRequire(event.target.value)
        } else {
            form_element.value = event.target.value;
        }
        // Auto-clear primary_parent if parent2_name is removed and no other parent2 data remains
        if (identifier === 'parent2_name' && !form_element.value &&
            update_add_student_form.primary_parent.value === 'p2' &&
            !update_add_student_form.parent2_email.value && !update_add_student_form.parent2_phone.value) {
            update_add_student_form.primary_parent.value = '';
        }
        // Check Validation
        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;

        update_add_student_form[identifier] = form_element;
        let is_form_valid = true;
        for (let identifier in update_add_student_form) {
            is_form_valid = update_add_student_form[identifier].valid && is_form_valid;
        }
        // this.setState({
        //     add_student_form: update_add_student_form,
        //     is_form_valid: is_form_valid,
        // });
        this.setState({
            add_student_form: update_add_student_form,
            is_form_valid: is_form_valid,
        }, () => {
            // Check if we need to reset parent2_as_host
            this.checkAndResetParent2Host();
        });
    }




    fahterDetailsRequire(parent1_name) {
        if (parent1_name !== '') {
            const update_add_student_form = { ...this.state.add_student_form };
            const update_parent_address_data = [...this.state.parent_address_data];

            update_add_student_form.parent1_email.validations.required = true
            update_add_student_form.parent1_phone.validations.required = true
            update_add_student_form.parent1_name.validations.required = true

            update_parent_address_data[0].address_line1.validations.required = false
            update_parent_address_data[0].address_line2.validations.required = false
            update_parent_address_data[0].parent_country.validations.required = true
            update_parent_address_data[0].parent_state.validations.required = false
            update_parent_address_data[0].parent_city.validations.required = false
            update_parent_address_data[0].parent_postcode.validations.required = false

            this.setState({ father_details: true })
            this.setState({ parent_address_data: update_parent_address_data })
            this.setState({ add_student_form: update_add_student_form })
        } else if (parent1_name === '') {
            const update_add_student_form = { ...this.state.add_student_form };
            const update_parent_address_data = [...this.state.parent_address_data];

            update_add_student_form.parent1_email.validations.required = false
            update_add_student_form.parent1_phone.validations.required = false
            update_add_student_form.parent1_name.validations.required = false

            update_parent_address_data[0].address_line1.validations.required = false
            update_parent_address_data[0].address_line2.validations.required = false
            update_parent_address_data[0].parent_country.validations.required = false
            update_parent_address_data[0].parent_state.validations.required = false
            update_parent_address_data[0].parent_city.validations.required = false
            update_parent_address_data[0].parent_postcode.validations.required = false

            this.setState({ father_details: false })
            this.setState({ parent_address_data: update_parent_address_data })
            this.setState({ add_student_form: update_add_student_form })
        }
    }
    mohterDetailsRequire(parent2_name) {
        if (parent2_name !== '') {
            const update_add_student_form = { ...this.state.add_student_form };
            const update_parent_address_data = [...this.state.parent_address_data];

            update_add_student_form.parent2_email.validations.required = false
            update_add_student_form.parent2_phone.validations.required = false
            update_add_student_form.parent2_name.validations.required = false

            update_parent_address_data[1].address_line1.validations.required = false
            update_parent_address_data[1].address_line2.validations.required = false
            update_parent_address_data[1].parent_country.validations.required = false
            update_parent_address_data[1].parent_state.validations.required = false
            update_parent_address_data[1].parent_city.validations.required = false
            update_parent_address_data[1].parent_postcode.validations.required = false

            // if (this.state.address_same_as_parent1 === false) {
            //     update_parent_address_data[1].address_line1.validations.required = false
            //     update_parent_address_data[1].address_line2.validations.required = false
            //     update_parent_address_data[1].parent_postcode.validations.required = false
            // }

            this.setState({ mother_details: true })
            this.setState({ parent_address_data: update_parent_address_data })
            this.setState({ add_student_form: update_add_student_form })
        } else if (parent2_name === '') {
            const update_add_student_form = { ...this.state.add_student_form };
            const update_parent_address_data = [...this.state.parent_address_data];

            update_add_student_form.parent2_email.validations.required = false
            update_add_student_form.parent2_phone.validations.required = false
            update_add_student_form.parent2_name.validations.required = false

            update_parent_address_data[1].address_line1.validations.required = false
            update_parent_address_data[1].address_line2.validations.required = false
            update_parent_address_data[1].parent_country.validations.required = false
            update_parent_address_data[1].parent_state.validations.required = false
            update_parent_address_data[1].parent_city.validations.required = false
            update_parent_address_data[1].parent_postcode.validations.required = false

            // if (this.state.address_same_as_parent1 === false) {
            //     update_parent_address_data[1].address_line1.validations.required = false
            //     update_parent_address_data[1].address_line2.validations.required = false
            //     update_parent_address_data[1].parent_postcode.validations.required = false
            // }

            console.log(update_add_student_form, "::2341234123")

            this.setState({ mother_details: false })
            this.setState({ parent_address_data: update_parent_address_data })
            this.setState({ add_student_form: update_add_student_form })
        }
    }




    /////////////////////// this function is make for student profile ///////////////////////////

    take_photo_by_props = (blob, identifier) => {
        if (identifier === "student_avatar") {
            let url = URL.createObjectURL(blob);
            let file = new File([blob], "image.png", { lastModified: new Date().getTime(), type: blob.type })
            const update_add_student_form = { ...this.state.add_student_form };
            const form_element = { ...update_add_student_form[identifier] };
            form_element.thumbnail_image = url;

            form_element.value = file;
            update_add_student_form[identifier] = form_element;
            this.setState({ add_student_form: update_add_student_form });

            this.setState({ cam_Start: null })
        } else {
            this.setState({ cam_Start: null })
        }
    }

    cam_not_available = (value) => {
        this.setState({ cam_Start: value })
        toast.info("camera not found", {
            position: toast.POSITION.TOP_CENTER,
        });
    }
    // react-advanced-cropper 

    onUpload = () => {
        if (this.inputRef.current) {
            this.inputRef.current.click();
        }
    };

    onCrop = () => {
        const cropper = this.cropperRef.current;
        if (cropper) {
            const canvas = cropper.getCanvas();
            if (canvas) {
                canvas.toBlob((blob) => {
                    if (blob) {
                        this.inputChangeHandlerimage(blob);
                    }
                });
            }
        }
    };
    inputChangeHandlerimage = blob => {
        const src = window.URL.createObjectURL(blob);
        let url = URL.createObjectURL(blob);
        let file = new File([blob], "image.png", { lastModified: new Date().getTime(), type: blob.type })
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form["student_avatar"] };
        form_element.thumbnail_image = url;

        form_element.value = file;
        update_add_student_form["student_avatar"] = form_element;
        this.setState({ add_student_form: update_add_student_form });
        this.setState({ OpenImageModal: !this.state.OpenImageModal })
    };

    ///////////////////////////// special function for student email ////////////////////// 

    studentEmailAddresssHandler(event, identifier) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };
        if (identifier === "student_email") {
            if (event.nativeEvent.data !== "@") {
                form_element.value = event.target.value.toLowerCase()
                form_element.error_msg = "";
            }
        }
        update_add_student_form[identifier] = form_element;
        this.setState({ add_student_form: update_add_student_form });
    }

    ///////////////////////////// student date of birth function /////////////////////////

    studentDateOfBirth(event, identifier) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };
        if (identifier === "date_of_birth") {
            const birthDate = new Date(event.target.value)
            const currDate = new Date();
            var ageDiff = currDate.getTime() - birthDate.getTime();
            var daydiff = (ageDiff / 31536000000).toFixed(0)
            if (daydiff <= 3) {
                alert("You must be above 4 years of age to join BSS school")
            } else {
                form_element.value = event.target.value;
            }
        }
        update_add_student_form[identifier] = form_element;
        this.setState({ add_student_form: update_add_student_form });
    }

    /////////////////////////////////////// student kioski pin length validation /////////////

    validatePinLength(event) {
        const { value, key } = event.target;
        if (!/^\d*$/.test(value) && key !== 'Backspace') {
            event.preventDefault();
            event.target.value = '';
        }
        if (value.length >= 6 && event.key !== 'Backspace') {
            event.preventDefault();
        }
    }


    /////////////////////////////////////// parent email handler ///////////////////////////

    parentEmailHandler(event, identifier) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };
        if (identifier === 'parent1_email') {
            if (event.target.value !== '') {
                this.GetParentDetailsByFatherEmail(event.target.value);
            }
            form_element.value = event.target.value.toLowerCase();
        }
        else if (identifier === 'parent2_email') {
            if (event.target.value !== '') {
                this.GetParentDetailsByMotherEmail(event.target.value);
            }
            form_element.value = event.target.value.toLowerCase();


            // Auto-clear first_point_email if parent2_email is removed and was selected
            if (!form_element.value && update_add_student_form.first_point_email.value === 'p2') {
                update_add_student_form.first_point_email.value = '';
            }
            // Auto-clear primary_parent if parent2_email is removed and no other parent2 data remains
            if (!form_element.value && update_add_student_form.primary_parent.value === 'p2' &&
                !update_add_student_form.parent2_name.value && !update_add_student_form.parent2_phone.value) {
                update_add_student_form.primary_parent.value = '';
            }
        }
        // Check Validation
        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;

        update_add_student_form[identifier] = form_element;
        let is_form_valid = true;
        for (let identifier in update_add_student_form) {
            is_form_valid = update_add_student_form[identifier].valid && is_form_valid;
        }
        this.setState({
            add_student_form: update_add_student_form,
            is_form_valid: is_form_valid,
        });
    }

    GetParentDetailsByFatherEmail = async (parent1_email) => {
        this.props.onGetParentDetailsByFatherEmail(parent1_email).then((response) => {
            if (response.success === true) {
                let student_data = response.data;
                const update_add_student_form = { ...this.state.add_student_form };
                const update_parent_address_data = [...this.state.parent_address_data]
                update_add_student_form['data_status'].value = JSON.stringify(student_data);
                if (response.data === null) {

                } else {
                    for (let key in update_add_student_form) {
                        let form_element = update_add_student_form[key];
                        if (student_data[key]) {
                            update_add_student_form['parent1_name'].value = student_data.parent1_name;
                            update_add_student_form['parent2_name'].value = student_data.parent2_name;
                            update_add_student_form['parent1_email'].value = student_data.parent1_email;
                            update_add_student_form['parent1_phone'].value = student_data.parent1_phone;

                            update_add_student_form['parent1_home_phone'].value = student_data.parent1_home_phone;
                            update_add_student_form['parent1_work_phone'].value = student_data.parent1_work_phone;
                            update_add_student_form['parent2_email'].value = student_data.parent2_email;
                            update_add_student_form['parent2_phone'].value = student_data.parent2_phone;
                            update_add_student_form['parent1_type'].value = student_data.parent1_type;
                            update_add_student_form['parent2_type'].value = student_data.parent2_type;

                            update_add_student_form['parent2_home_phone'].value = student_data.parent2_home_phone;
                            update_add_student_form['parent2_work_phone'].value = student_data.parent2_work_phone;
                            update_add_student_form['parent_id'].value = student_data.parent_id;

                            update_add_student_form.parent1_email.validations.required = true
                            update_add_student_form.parent1_phone.validations.required = true
                            update_add_student_form.parent1_name.validations.required = true
                            update_parent_address_data[0].parent_country.validations.required = true
                            update_add_student_form.parent2_email.validations.required = true
                            update_add_student_form.parent2_phone.validations.required = true
                            update_add_student_form.parent2_name.validations.required = true


                            this.setState({ add_student_form: update_add_student_form });
                            update_add_student_form[key] = form_element;
                        }
                    }
                    update_parent_address_data.forEach(element => {
                        student_data.parent_address.forEach(ele => {
                            if (element.parent_address_type.value === ele.parent_address_type) {
                                element.address_line1.value = ele.address_line1
                                element.address_line2.value = ele.address_line2
                                element.parent_country.value = ele.parent_country
                                element.parent_state.value = ele.parent_state
                                element.parent_city.value = ele.parent_city
                                element.parent_postcode.value = ele.parent_postcode
                                element.parent_address_type.value = ele.parent_address_type

                            }
                        })
                    });
                }
                this.setState({ add_student_form: update_add_student_form });
                this.setState({ parent_address_data: update_parent_address_data })
            } else {
            }
        });
    }

    GetParentDetailsByMotherEmail = async (parent2_email) => {
        this.props.onGetParentDetailsByMotherEmail(parent2_email).then((response) => {
            if (response.success === true) {
                let student_data = response.data;
                const update_add_student_form = { ...this.state.add_student_form };
                const update_parent_address_data = [...this.state.parent_address_data]
                update_add_student_form['data_status'].value = JSON.stringify(student_data);
                if (response.data === null) {

                } else {

                    for (let key in update_add_student_form) {
                        let form_element = update_add_student_form[key];
                        if (student_data[key]) {
                            update_add_student_form['parent1_name'].value = student_data.parent1_name;
                            update_add_student_form['parent2_name'].value = student_data.parent2_name;
                            update_add_student_form['parent1_email'].value = student_data.parent1_email;
                            update_add_student_form['parent1_phone'].value = student_data.parent1_phone;

                            update_add_student_form['parent1_home_phone'].value = student_data.parent1_home_phone;
                            update_add_student_form['parent1_work_phone'].value = student_data.parent1_work_phone;
                            update_add_student_form['parent2_email'].value = student_data.parent2_email;
                            update_add_student_form['parent2_phone'].value = student_data.parent2_phone;

                            update_add_student_form['parent2_home_phone'].value = student_data.parent2_home_phone;
                            update_add_student_form['parent2_work_phone'].value = student_data.parent2_work_phone;
                            update_add_student_form['parent_id'] = student_data.parent_id;

                            this.setState({ add_student_form: update_add_student_form });
                            update_add_student_form[key] = form_element;
                        }
                    }
                    update_parent_address_data.forEach(element => {
                        student_data.parent_address.forEach(ele => {
                            if (element.parent_address_type.value === ele.parent_address_type) {
                                element.address_line1.value = ele.address_line1
                                element.address_line2.value = ele.address_line2
                                element.parent_country.value = ele.parent_country
                                element.parent_state.value = ele.parent_state
                                element.parent_city.value = ele.parent_city
                                element.parent_postcode.value = ele.parent_postcode
                                element.parent_address_type.value = ele.parent_address_type

                            }
                        })
                    });
                }
                this.setState({ add_student_form: update_add_student_form });
                this.setState({ parent_address_data: update_parent_address_data })
            } else {
            }
        });
    }




    /////////////// this function for class , dormitory , first point of contact parent1 and parent2 /////////////////

    selectHandleChange(data, identifier, type) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };
        if (identifier === 'dormitory_id') {
            update_add_student_form['dormitory_id_name'].value = data.label;
        } if (identifier === 'class_id') {
            update_add_student_form['class_name'].value = data.label;
        }
        form_element.value = data.value;
        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;
        update_add_student_form[identifier] = form_element;
        this.setState({ add_student_form: update_add_student_form });
    }

    ////////////////////////// handle all phone numbers but not host phone number //////////////////////////////////

    // event -> raw value, identifier -> field name, formatted -> formattedValue (e.g. '+509 83520028')
    phoneNumberHandler(event, identifier, formatted) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };
        // prefer formatted value when provided by ReactPhoneInput
        form_element.value = formatted && typeof formatted === 'string' ? formatted : event;
        const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
        update_add_student_form['school_name'].value = user_info.user_school.school_name;
        update_add_student_form['school_detail_id'].value = user_info.user_school.school_detail_id;
        // Auto-clear first_point_contact if parent2_phone is removed and was selected
        if (identifier === 'parent2_phone' && !form_element.value &&
            update_add_student_form.first_point_contact.value === 'p2') {
            update_add_student_form.first_point_contact.value = '';
        }
        // Auto-clear primary_parent if parent2_phone is removed and no other parent2 data remains
        if (identifier === 'parent2_phone' && !form_element.value &&
            update_add_student_form.primary_parent.value === 'p2' &&
            !update_add_student_form.parent2_name.value && !update_add_student_form.parent2_email.value) {
            update_add_student_form.primary_parent.value = '';
        }
        // Check Validation
        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;

        update_add_student_form[identifier] = form_element;
        let is_form_valid = true;
        for (let identifier in update_add_student_form) {
            is_form_valid = update_add_student_form[identifier].valid && is_form_valid;
        }
        this.setState({
            add_student_form: update_add_student_form,
            is_form_valid: is_form_valid,
        });

    }

    /////////////////////////////////// parent country handler ///////////////////////////

    selectParentCountry(data, index, identifier) {
        const update_parent_address_data = [...this.state.parent_address_data];
        if (!update_parent_address_data[index]) {
            update_parent_address_data[index] = {};
        }
        const update_parents_data = { ...update_parent_address_data[index] }
        if (!update_parents_data[identifier]) {
            update_parents_data[identifier] = {}
        }
        if (identifier === "parent_country") {
            if (index === 0) {
                this.GetAllStatesByCountryIdForFather(data.value)
                // update_parents_data[identifier].value = data.label;
                // update_parents_data[identifier].country_code = data.country_code;

                const form_element = update_parents_data[identifier];
                form_element.value = data.label
                form_element.country_code = data.country_code;
                let validate_element = Validation(form_element);
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                update_parents_data[identifier] = form_element;
                update_parent_address_data[index] = update_parents_data
            } else {
                this.GetAllStatesByCountryIdForMother(data.value)
                // update_parents_data[identifier].value = data.label;
                // update_parents_data[identifier].country_code = data.country_code;

                const form_element = update_parents_data[identifier];
                form_element.value = data.label
                form_element.country_code = data.country_code;
                let validate_element = Validation(form_element);
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                update_parents_data[identifier] = form_element;
                update_parent_address_data[index] = update_parents_data
            }
        }
        if (identifier === "parent_state") {
            if (index === 0) {
                this.GetAllCitiesByStateIdForFather(data.value)
                update_parents_data[identifier].value = data.label;
            } else {
                this.GetAllCitiesByStateIdForMother(data.value)
                update_parents_data[identifier].value = data.label;
            }
        }
        if (identifier === "parent_city") {
            if (index === 0) {
                update_parents_data[identifier].value = data.label;
            } else {
                update_parents_data[identifier].value = data.label;
            }
        }
        update_parent_address_data[index] = update_parents_data
        this.setState({ parent_address_data: update_parent_address_data });
    }

    /////////////////////////////// for parents address function /////////////////////////

    parentAddressHandler(event, index, identifier) {
        const update_same_as_parent1 = { ...this.state.address_same_as_parent1 };
        const update_parent_address_data = this.state.parent_address_data;
        if (update_same_as_parent1.value) {
            update_parent_address_data[0][identifier].value = event.target.value;
            update_parent_address_data[1][identifier].value = event.target.value;

        } else {
            if (!update_parent_address_data[index]) {
                update_parent_address_data[index] = {};
            }
            const update_parents_data = { ...update_parent_address_data[index] }
            if (!update_parents_data[identifier]) {
                update_parents_data[identifier] = {}
            }
            update_parents_data[identifier].value = event.target.value;
            const form_element = update_parents_data[identifier];
            let validate_element = Validation(form_element);
            form_element.valid = validate_element.valid;
            form_element.error_msg = validate_element.error_msg;
            update_parents_data[identifier] = form_element;
            update_parent_address_data[index] = update_parents_data
        }
        this.setState({ parent_address_data: update_parent_address_data });
    }

    //////////////////////////// parent all checkbox handler /////////////////////

    inputParentCheckbox(event, identifier) {
        const update_same_as_parent1 = { ...this.state.address_same_as_parent1 };
        const update_parent1_as_host = { ...this.state.parent1_as_host }
        const update_parent2_as_host = { ...this.state.parent2_as_host }
        const update_parent_address = this.state.parent_address_data
        console.log(this.state.parent1_as_host.value, "update_parent1_as_host")

        console.log(this.state.parent2_as_host.value, "this.state.parent2_as_host.valuethis.state.parent2_as_host.valuethis.state.parent2_as_host.value")
        if (identifier === "address_same_as_parent1") {
            update_same_as_parent1.value = event.target.checked;
            update_same_as_parent1.isChecked = event.target.checked;
            this.setState({ address_same_as_parent1: update_same_as_parent1 });
            if (update_same_as_parent1.value) {
                const getcountry_id = this.state.country_id.options.find((country) => country.label.toLowerCase() === update_parent_address[0].parent_country.value.toLowerCase())
                if (getcountry_id !== undefined) {
                    this.GetAllStatesByCountryIdForMother(getcountry_id.value)
                }
                const getstate_id = this.state.parent_address_data[0].parent_state.options.find((state) => state.label.toLowerCase() === this.state.parent_address_data[0].parent_state.value.toLowerCase())
                if (getstate_id !== undefined) {
                    this.GetAllCitiesByStateIdForMother(getstate_id.value)
                }
                update_parent_address[1].address_line1.value = update_parent_address[0].address_line1.value
                update_parent_address[1].address_line2.value = update_parent_address[0].address_line2.value
                update_parent_address[1].parent_country.value = update_parent_address[0].parent_country.value
                update_parent_address[1].parent_state.value = update_parent_address[0].parent_state.value
                update_parent_address[1].parent_city.value = update_parent_address[0].parent_city.value
                update_parent_address[1].parent_postcode.value = update_parent_address[0].parent_postcode.value
                update_parent_address[1].parent_address_type.value = update_parent_address[0].parent_address_type.value
            }
            this.setState({ parent_address_data: update_parent_address })
        }
        if (identifier === "parent1_as_host") {
            update_parent1_as_host.value = !event.target.checked;
            update_parent1_as_host.isChecked = event.target.checked;
            this.setState({ parent1_as_host: update_parent1_as_host });
        }
        if (identifier === "parent2_as_host") {
            update_parent2_as_host.value = !event.target.checked;
            update_parent2_as_host.isChecked = event.target.checked;
            this.setState({ parent2_as_host: update_parent2_as_host });
        }
    }
    ////////////////////////////////// get host data by host email and phone number //////////////////////

    GetStudentHostByHostEmail = async (host_email) => {
        this.props.onGetStudentHostByHostEmail(host_email).then((response) => {
            if (response.success === true) {
                let student_data = response.data;
                const update_host_data = { ...this.state.host_data };
                update_host_data['data_status'].value = JSON.stringify(student_data);
                if (student_data === null) {
                } else {
                    for (let key in update_host_data) {
                        let form_element = update_host_data[key];
                        if (student_data[key]) {
                            update_host_data['host_name'].value = student_data.host_name;
                            // update_host_data['host_relation'].value = student_data?.stu_host?.host_relation;
                            update_host_data['host_contact'].value = student_data.host_contact;
                            update_host_data['host_email'].value = student_data.host_email;

                            update_host_data['host_address'].value = student_data.host_address;
                            update_host_data['remark_parents'].value = student_data.remark_parents;
                            update_host_data['remark_boarding'].value = student_data.remark_boarding;
                            update_host_data['remark_host'].value = student_data.remark_host;
                            update_host_data['host_id'].value = student_data.host_id;

                            update_host_data['host_matched'].value = true;

                            this.setState({ host_data: update_host_data });
                            update_host_data[key] = form_element
                        }
                    }
                }
                this.setState({ host_data: update_host_data })
            } else {

            }
        })
    }

    GetStudentHostByHostContact = async (host_contact) => {
        this.props.onGetStudentHostByHostContact(host_contact).then((response) => {
            const update_host_matched = this.state.host_matched;
            const update_host_data = { ...this.state.host_data }
            if (response.success === true) {
                let student_data = response.data;
                update_host_data['data_status'].value = JSON.stringify(student_data);
                if (student_data === null) {

                } else {
                    for (let key in update_host_data) {
                        let form_element = update_host_data[key];
                        if (student_data[key]) {
                            update_host_data['host_name'].value = student_data.host_name;
                            update_host_data['host_contact'].value = student_data.host_contact;
                            update_host_data['host_email'].value = student_data.host_email;

                            update_host_data['host_address'].value = student_data.host_address;
                            update_host_data['remark_parents'].value = student_data.remark_parents;
                            update_host_data['remark_boarding'].value = student_data.remark_boarding;
                            update_host_data['remark_host'].value = student_data.remark_host;
                            update_host_data['host_id'].value = student_data.host_id;

                            this.setState({ host_data: update_host_data });
                            update_host_data[key] = form_element;
                        }
                    }
                    this.setState({
                        host_data: update_host_data,
                        host_matched: false
                    });
                }
            } else {
            }
        });
    }

    //////////////////////////////// host input handler with host phone number /////////////////

    inputChangeHost(event, identifier) {
        const update_host_data = { ...this.state.host_data }
        const form_element = { ...update_host_data[identifier] };
        if (identifier === 'host_contact') {
            this.GetStudentHostByHostContact(event);
            form_element.value = event;
        }

        else if (identifier === 'host_email') {
            this.GetStudentHostByHostEmail(event.target.value);
            form_element.value = event.target.value.toLowerCase();
        } else {
            form_element.value = event.target.value;
        }
        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;
        update_host_data[identifier] = form_element;
        this.setState({ host_data: update_host_data })
    }

    //////////////////////////////// host checkbox //////////////////////////////

    inputChangehostCheckbox(event) {
        const update_host_data = { ...this.state.host_data };
        const form_element = { ...update_host_data.is_host_approved };
        if (form_element.type === "checkbox") {
            if (form_element.value === true) {
                form_element.value = event.target.checked;
                form_element.value = false
            } else {
                form_element.value = event.target.checked;
                form_element.value = true
            }
        } else {
            form_element.value = event.target.value;
        }
        update_host_data.is_host_approved = form_element;
        this.setState({ host_data: update_host_data });
    }

    //////////////////////////////// additional hosts methods //////////////////
    addAdditionalHost = () => {
        let newHost = {
            host_id: { type: "hidden", value: "", valid: true, error_msg: "", onBlur_out: false, validations: { required: false } },
            host_name: { type: "text", label: "Host Name *", value: "", valid: true, error_msg: "", onBlur_out: false, placeholder: "", validations: { required: true } },
            host_relation: { type: "text", label: "Host's Relation *", value: "", valid: true, error_msg: "", onBlur_out: false, placeholder: "", validations: { required: true } },
            host_email: { type: "email", label: "Host's Email *", value: "", valid: true, error_msg: "", onBlur_out: false, placeholder: "", validations: { required: true, email: true } },
            host_contact: { type: "text", label: "Host's Mobile Number *", value: "", valid: true, error_msg: "", onBlur_out: false, placeholder: "", validations: { required: true } },
            host_address: { type: "text", label: "Host's Address *", value: "", valid: true, error_msg: "", onBlur_out: false, placeholder: "", validations: { required: true } },
            is_host_approved: { type: "checkbox", label: "This Host will be automatically Approved", value: true, valid: true, error_msg: "", validations: { required: false } },
            data_status: { type: "hidden", label: "data_status", value: "null", valid: true, error_msg: "", onBlur_out: false, validations: { required: false } },
            host_matched: { type: "text", value: false, valid: true, error_msg: "", onBlur_out: false, validations: { required: false } },
        };
        this.setState({ additional_hosts_data: [...(this.state.additional_hosts_data || []), newHost] });
    }

    removeAdditionalHost = (index) => {
        let additionalHosts = [...this.state.additional_hosts_data];
        additionalHosts.splice(index, 1);
        this.setState({ additional_hosts_data: additionalHosts });
    }

    GetAdditionalHostByEmail = async (host_email, index) => {
        this.props.onGetStudentHostByHostEmail(host_email).then((response) => {
            if (response.success === true) {
                let student_data = response.data;
                let hosts = [...this.state.additional_hosts_data];
                let host = { ...hosts[index] };
                host['data_status'].value = JSON.stringify(student_data);
                if (student_data !== null) {
                    for (let key in host) {
                        let form_element = host[key];
                        if (student_data[key]) {
                            host['host_name'].value = student_data.host_name;
                            host['host_contact'].value = student_data.host_contact;
                            host['host_email'].value = student_data.host_email;
                            host['host_address'].value = student_data.host_address;
                            host['host_id'].value = student_data.host_id;
                            host['host_matched'].value = true;
                            host[key] = form_element;
                        }
                    }
                }
                hosts[index] = host;
                this.setState({ additional_hosts_data: hosts });
            }
        });
    }

    GetAdditionalHostByContact = async (host_contact, index) => {
        this.props.onGetStudentHostByHostContact(host_contact).then((response) => {
            if (response.success === true) {
                let student_data = response.data;
                let hosts = [...this.state.additional_hosts_data];
                let host = { ...hosts[index] };
                host['data_status'].value = JSON.stringify(student_data);
                if (student_data !== null) {
                    for (let key in host) {
                        let form_element = host[key];
                        if (student_data[key]) {
                            host['host_name'].value = student_data.host_name;
                            host['host_contact'].value = student_data.host_contact;
                            host['host_email'].value = student_data.host_email;
                            host['host_address'].value = student_data.host_address;
                            host['host_id'].value = student_data.host_id;
                            host[key] = form_element;
                        }
                    }
                }
                hosts[index] = host;
                this.setState({ additional_hosts_data: hosts });
            }
        });
    }

    inputChangeAdditionalHost(event, index, identifier) {
        let hosts = [...this.state.additional_hosts_data];
        let host = { ...hosts[index] };
        let form_element = { ...host[identifier] };

        if (identifier === 'host_contact') {
            this.GetAdditionalHostByContact(event, index);
            form_element.value = event;
        } else if (identifier === 'host_email') {
            const valObj = event.target ? event.target.value : event;
            this.GetAdditionalHostByEmail(valObj, index);
            form_element.value = valObj.toLowerCase();
        } else {
            const valObj = event.target ? event.target.value : event;
            form_element.value = valObj;
        }

        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;
        host[identifier] = form_element;
        hosts[index] = host;
        this.setState({ additional_hosts_data: hosts });
    }

    inputChangeAdditionalHostCheckbox(event, index) {
        let hosts = [...this.state.additional_hosts_data];
        let host = { ...hosts[index] };
        let form_element = { ...host.is_host_approved };
        form_element.value = event.target.checked;
        host.is_host_approved = form_element;
        hosts[index] = host;
        this.setState({ additional_hosts_data: hosts });
    }

    ///////////////////////// Allergy function add allergy ,delete Allergy , input handler ///////////////////

    inputChangeAllergyName(event, identifier, value) {
        let setName = this.state.allergy_data
        setName[value].allergy_name = event.target.value
        this.setState({ rowname: setName.allergy_name })
    }

    inputChangeAllergyInfo(event, identifier, value) {
        let setInfo = this.state.allergy_data
        setInfo[value].allergy_info = event.target.value
        this.setState({ rowinfo: setInfo.allergy_info })
    }

    clickAddAllergyrow() {
        const update_row = this.state.allergy_data;
        let counter = update_row.length
        update_row.push(
            {
                id: counter++,
                allergy_name: "",
                allergy_info: ""
            }
        )
        this.setState({ allergy_data: update_row })
    }
    clickDeleteAllergyrow = (index, e) => {
        if (this.state.allergy_data.length > 1) {
            const delete_row = [...this.state.allergy_data];
            this.setState({ allergy_data: delete_row.filter((i) => i !== index) })
        }
    };

    /////////////////////////////// last card check box handler //////////////////////////////

    inputChangeHandlerCheckbox(event, identifier) {
        const update_add_student_form = { ...this.state.add_student_form };
        const form_element = { ...update_add_student_form[identifier] };

        if (form_element.type === "checkbox") {
            form_element.value = event.target.checked;
            form_element.isChecked = event.target.checked;
        } else {
            form_element.value = event.target.value;
        }

        // Check Validation
        let validate_element = Validation(form_element);
        form_element.valid = validate_element.valid;
        form_element.error_msg = validate_element.error_msg;

        update_add_student_form[identifier] = form_element;
        this.setState({ add_student_form: update_add_student_form });
    }

    // handleCheckboxChange = () => {
    //     this.setState((prevState) => ({
    //         showInput: !prevState.showInput,
    //         add_student_form: {
    //         ...prevState.add_student_form,
    //         unique_student_number: {
    //             ...prevState.add_student_form.unique_student_number,
    //             value: !prevState.showInput ? "" : prevState.add_student_form.unique_student_number.value, // Clear the value if disabled
    //         },
    //         },
    //     }));
    // };

    handleCheckboxChange = () => {
        this.setState((prevState) => {
            const nextShowInput = !prevState.add_student_form.showInput;
            return {
                add_student_form: {
                    ...prevState.add_student_form,
                    showInput: nextShowInput,
                    unique_pin: {
                        ...prevState.add_student_form.unique_pin,
                        value: "",
                        valid: true,
                        error_msg: "",
                        onBlur_out: false,
                    },
                    kiosk_mode_pin: {
                        ...prevState.add_student_form.kiosk_mode_pin,
                        value: "",
                        // Auto-generate ON (nextShowInput=true)  → always valid, no entry needed
                        // Manual entry ON  (nextShowInput=false) → invalid until user types 6 digits
                        valid: nextShowInput ? true : false,
                        error_msg: "",       // Don't show error until user interacts
                        onBlur_out: false,   // Hide error message on fresh toggle
                    }
                }
            };
        });
    };


    handleInputChange = (event) => {
        const value = event.target.value;
        const regex = /^[a-zA-Z0-9]{0,7}$/;

        // if (/^([A-Za-z]{0,3}|[A-Za-z]{3}\d)$/.test(value)) {
        if (regex.test(value)) {
            // if (/^\d{0,7}$/.test(value)) {
            this.setState((prevState) => ({
                add_student_form: {
                    ...prevState.add_student_form,
                    unique_pin: {
                        ...prevState.add_student_form.unique_pin,
                        value: value,
                    },
                },
            }));
        }
    };


    handleFocus = () => {
        this.setState({ showTooltip: true });
    };

    handleBlur = () => {
        // if you also have an onBlur_out logic, handle it here
        this.setState({ showTooltip: false });
    };

    SubmitHandler = async (event) => {
        event.preventDefault();
        let is_form_valid = true;
        const update_add_student_form = this.state.add_student_form;
        const update_parent_address = this.state.parent_address_data;
        const update_host_data = this.state.host_data;

        console.group("🚀 SUBMIT HANDLER STARTED");
        console.log("showInput (auto-generate kiosk):", update_add_student_form.showInput);
        console.log("father_details:", this.state.father_details);
        console.log("mother_details:", this.state.mother_details);
        console.log("Full add_student_form state:", update_add_student_form);
        console.log("Full host_data state:", update_host_data);
        console.log("Full parent_address_data state:", update_parent_address);
        console.groupEnd();

        // ── STUDENT FORM VALIDATION LOOP ──
        console.group("📋 STUDENT FORM VALIDATION");
        for (let key in update_add_student_form) {
            if (key === 'showInput') {
                console.log(`⏭️ SKIPPING non-field key: ${key}`);
                continue;
            }

            if (key === 'student_email') {
                let form_element = update_add_student_form[key];
                const old_value = form_element.value;
                const email_Obj = form_element;
                email_Obj.value = email_Obj.value + this.state.school_domain;
                let validate_element = Validation(email_Obj);
                is_form_valid = validate_element.valid === false ? false : is_form_valid;
                form_element.onBlur_out = true;
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                form_element.value = old_value;
                update_add_student_form[key] = form_element;
                console.log(`[student_email] value: "${old_value}${this.state.school_domain}" | valid: ${validate_element.valid} | error: "${validate_element.error_msg}"`);

            } else if (key === 'parent1_email' || key === 'parent2_email') {
                let form_element = update_add_student_form[key];
                const old_value = form_element.value;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                let validate_element;
                if (old_value.trim() === '' && !form_element.validations.required) {
                    validate_element = { valid: true, error_msg: "" };
                } else if (old_value.trim() === '' && form_element.validations.required) {
                    validate_element = { valid: false, error_msg: "This field is required." };
                } else {
                    validate_element = {
                        valid: emailRegex.test(old_value),
                        error_msg: emailRegex.test(old_value) ? "" : "Please enter a valid email address."
                    };
                }
                is_form_valid = validate_element.valid === false ? false : is_form_valid;
                form_element.onBlur_out = true;
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                form_element.value = old_value;
                update_add_student_form[key] = form_element;
                console.log(`[${key}] value: "${old_value}" | required: ${form_element.validations.required} | valid: ${validate_element.valid} | error: "${validate_element.error_msg}"`);

            }
            // else if (key === 'unique_pin') {
            //     if (!this.state.add_student_form.showInput) {
            //         let form_element = update_add_student_form[key];
            //         let isValue7Chars = form_element.value.length === 7;
            //         let validate_element = {
            //             valid: isValue7Chars,
            //             error_msg: isValue7Chars ? "" : "Unique number must be exactly 7 characters.",
            //         };
            //         is_form_valid = !validate_element.valid ? false : is_form_valid;
            //         form_element.onBlur_out = true;
            //         form_element.valid = validate_element.valid;
            //         form_element.error_msg = validate_element.error_msg;
            //         update_add_student_form[key] = form_element;
            //         console.log(`[unique_pin] value: "${form_element.value}" | length: ${form_element.value.length} | valid: ${validate_element.valid} | error: "${validate_element.error_msg}"`);
            //     } else {
            //         let form_element = update_add_student_form[key];
            //         form_element.valid = true;
            //         form_element.error_msg = "";
            //         update_add_student_form[key] = form_element;
            //         console.log(`[unique_pin] SKIPPED — auto-generate is ON | marked valid: true`);
            //     }
            //     } 
            else if (key === 'unique_pin') {
                // unique_pin field is hidden in UI (display:none) — always mark valid, never block submission
                let form_element = update_add_student_form[key];
                form_element.valid = true;
                form_element.error_msg = "";
                update_add_student_form[key] = form_element;
                console.log(`[unique_pin] ALWAYS SKIPPED — hidden field, never blocks submission`);

            } else if (key === 'kiosk_mode_pin') {
                if (!this.state.add_student_form.showInput) {
                    let form_element = update_add_student_form[key];
                    let isExactly6 = form_element.value.length === 6;
                    let validate_element = {
                        valid: isExactly6,
                        error_msg: isExactly6 ? "" : "Kiosk pin must be exactly 6 digits.",
                    };
                    is_form_valid = !validate_element.valid ? false : is_form_valid;
                    form_element.onBlur_out = true;
                    form_element.valid = validate_element.valid;
                    form_element.error_msg = validate_element.error_msg;
                    update_add_student_form[key] = form_element;
                    console.log(`[kiosk_mode_pin] value: "${form_element.value}" | length: ${form_element.value.length} | valid: ${validate_element.valid} | error: "${validate_element.error_msg}"`);
                } else {
                    let form_element = update_add_student_form[key];
                    form_element.valid = true;
                    form_element.error_msg = "";
                    update_add_student_form[key] = form_element;
                    console.log(`[kiosk_mode_pin] SKIPPED — auto-generate is ON | marked valid: true`);
                }

            } else {
                let form_element = update_add_student_form[key];
                if (!form_element || typeof form_element !== 'object' || !('validations' in form_element)) {
                    console.warn(`⚠️ SKIPPING key "${key}" — not a valid form field object. Value:`, form_element);
                    continue;
                }
                let validate_element = Validation(form_element);
                is_form_valid = validate_element.valid === false ? false : is_form_valid;
                form_element.onBlur_out = true;
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                update_add_student_form[key] = form_element;
                if (!validate_element.valid) {
                    console.warn(`❌ INVALID [${key}] value: "${form_element.value}" | required: ${form_element.validations?.required} | error: "${validate_element.error_msg}"`);
                } else {
                    console.log(`✅ VALID [${key}] value: "${form_element.value}"`);
                }
            }
        }
        console.log("is_form_valid after student loop:", is_form_valid);
        console.groupEnd();

        // ── HOST DATA VALIDATION LOOP ──
        console.group("🏠 HOST DATA VALIDATION");
        for (let key in update_host_data) {
            let form_element = update_host_data[key];
            if (!form_element || typeof form_element !== 'object' || !('validations' in form_element)) {
                console.warn(`⚠️ SKIPPING host key "${key}" — not a valid form field object. Value:`, form_element);
                continue;
            }
            let validate_element = Validation(form_element);
            is_form_valid = validate_element.valid === false ? false : is_form_valid;
            form_element.onBlur_out = true;
            form_element.valid = validate_element.valid;
            form_element.error_msg = validate_element.error_msg;
            update_host_data[key] = form_element;
            if (!validate_element.valid) {
                console.warn(`❌ INVALID [HOST ${key}] value: "${form_element.value}" | required: ${form_element.validations?.required} | error: "${validate_element.error_msg}"`);
            } else {
                console.log(`✅ VALID [HOST ${key}] value: "${form_element.value}"`);
            }
        }
        console.log("is_form_valid after host loop:", is_form_valid);
        console.groupEnd();

        console.group("➕ ADDITIONAL HOSTS VALIDATION");
        let additional_hosts = this.state.additional_hosts_data || [];
        for (let i = 0; i < additional_hosts.length; i++) {
            let update_host = { ...additional_hosts[i] };
            for (let key in update_host) {
                let form_element = update_host[key];
                if (!form_element || typeof form_element !== 'object' || !('validations' in form_element)) {
                    continue;
                }
                let validate_element = Validation(form_element);
                is_form_valid = validate_element.valid === false ? false : is_form_valid;
                form_element.onBlur_out = true;
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                update_host[key] = form_element;
            }
            additional_hosts[i] = update_host;
        }
        this.setState({ additional_hosts_data: additional_hosts });
        console.groupEnd();

        // ── PARENT ADDRESS VALIDATION LOOP ──
        console.group("🏡 PARENT ADDRESS VALIDATION");
        for (let index in update_parent_address) {
            let update_father_address = update_parent_address[0];
            let update_mother_address = update_parent_address[1];

            for (let key in update_father_address) {
                let form_element = update_father_address[key];
                if (!form_element || typeof form_element !== 'object' || !('validations' in form_element)) {
                    console.warn(`⚠️ SKIPPING parent1 address key "${key}" — not a valid form field object.`);
                    continue;
                }
                let validate_element = Validation(form_element);
                is_form_valid = validate_element.valid === false ? false : is_form_valid;
                form_element.onBlur_out = true;
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                update_father_address[key] = form_element;
                if (!validate_element.valid) {
                    console.warn(`❌ INVALID [PARENT1 ADDRESS ${key}] value: "${form_element.value}" | required: ${form_element.validations?.required} | error: "${validate_element.error_msg}"`);
                } else {
                    console.log(`✅ VALID [PARENT1 ADDRESS ${key}] value: "${form_element.value}"`);
                }
            }

            for (let key in update_mother_address) {
                let form_element = update_mother_address[key];
                if (!form_element || typeof form_element !== 'object' || !('validations' in form_element)) {
                    console.warn(`⚠️ SKIPPING parent2 address key "${key}" — not a valid form field object.`);
                    continue;
                }
                let validate_element = Validation(form_element);
                is_form_valid = validate_element.valid === false ? false : is_form_valid;
                form_element.onBlur_out = true;
                form_element.valid = validate_element.valid;
                form_element.error_msg = validate_element.error_msg;
                update_mother_address[key] = form_element;
                if (!validate_element.valid) {
                    console.warn(`❌ INVALID [PARENT2 ADDRESS ${key}] value: "${form_element.value}" | required: ${form_element.validations?.required} | error: "${validate_element.error_msg}"`);
                } else {
                    console.log(`✅ VALID [PARENT2 ADDRESS ${key}] value: "${form_element.value}"`);
                }
            }
            break; // parent_address_data only has 2 entries, loop once is enough
        }
        console.log("is_form_valid after parent address loop:", is_form_valid);
        console.groupEnd();

        this.setState({ host_data: update_host_data });
        this.setState({ parent_address_data: update_parent_address });
        this.setState({ add_student_form: update_add_student_form });

        console.group("🏁 FINAL DECISION");
        console.log("father_details:", this.state.father_details);
        console.log("mother_details:", this.state.mother_details);
        console.log("FINAL is_form_valid:", is_form_valid);
        console.groupEnd();

        if (this.state.mother_details === false && this.state.father_details === false) {
            toast.error("Please fill parent 1 details to submit the form", {
                position: toast.POSITION.TOP_CENTER,
            });
            console.error("🚫 BLOCKED: both mother_details and father_details are false");
            return;
        }

        if (is_form_valid) {
            console.log("✅ FORM IS VALID — calling API...");
            const form_data = {};
            const hasParent2Data = this.state.add_student_form.parent2_name.value ||
                this.state.add_student_form.parent2_email.value ||
                this.state.add_student_form.parent2_phone.value;

            for (let key in this.state.add_student_form) {
                if (key === 'showInput') continue;
                if (key === 'student_email') {
                    const email = this.state.add_student_form['student_email'].value + this.state.school_domain;
                    form_data[key] = email;
                } else if (key === "date_of_birth") {
                    form_data[key] = moment(this.state.add_student_form['date_of_birth'].value).format('YYYY-MM-DD');
                } else {
                    form_data[key] = this.state.add_student_form[key].value;
                }
            }

            let oldArray = this.state.allergy_data;
            let update_allergy_data = oldArray.map((item) => ({
                allergy_name: item.allergy_name,
                allergy_info: item.allergy_info
            }));
            form_data['allergy_data'] = JSON.stringify(update_allergy_data);

            let hosts_payload = [];
            let first_host = {
                "host_name": this.state.host_data.host_name.value,
                "host_relation": this.state.host_data?.host_relation?.value,
                "host_email": this.state.host_data.host_email.value,
                "host_contact": this.state.host_data.host_contact.value,
                "host_address": this.state.host_data.host_address.value,
                "is_host_approved": this.state.host_data.is_host_approved.value,
                "remark_parents": this.state.host_data.remark_parents.value,
                "remark_boarding": this.state.host_data.remark_boarding.value,
                "remark_host": this.state.host_data.remark_host.value,
            };
            let update_host_id = this.state.host_data.host_id.value;
            if (update_host_id) { first_host.host_id = update_host_id; }

            if (first_host.host_name) {
                hosts_payload.push(first_host);
            }

            if (this.state.additional_hosts_data && this.state.additional_hosts_data.length > 0) {
                this.state.additional_hosts_data.forEach(h => {
                    let h_data = {
                        "host_name": h.host_name.value,
                        "host_relation": h.host_relation?.value,
                        "host_email": h.host_email.value,
                        "host_contact": h.host_contact.value,
                        "host_address": h.host_address.value,
                        "is_host_approved": h.is_host_approved.value,
                        "remark_parents": this.state.host_data.remark_parents.value,
                        "remark_boarding": this.state.host_data.remark_boarding.value,
                        "remark_host": this.state.host_data.remark_host.value,
                    };
                    if (h.host_id.value) { h_data.host_id = h.host_id.value; }
                    hosts_payload.push(h_data);
                });
            }

            if (hosts_payload.length > 0) {
                form_data['host_data'] = JSON.stringify(hosts_payload);
            }

            if (this.state.address_same_as_parent1.value === false) {
                if (this.state.father_details === true && this.state.mother_details === true) {
                    form_data['parent_address_data'] = JSON.stringify([
                        {
                            address_line1: this.state.parent_address_data[0].address_line1.value,
                            address_line2: this.state.parent_address_data[0].address_line2.value,
                            parent_state: this.state.parent_address_data[0].parent_state.value,
                            parent_city: this.state.parent_address_data[0].parent_city.value,
                            parent_postcode: this.state.parent_address_data[0].parent_postcode.value,
                            parent_country: this.state.parent_address_data[0].parent_country.value,
                            parent_address_type: this.state.parent_address_data[0].parent_address_type.value,
                        },
                        {
                            address_line1: this.state.parent_address_data[1].address_line1.value,
                            address_line2: this.state.parent_address_data[1].address_line2.value,
                            parent_state: this.state.parent_address_data[1].parent_state.value,
                            parent_city: this.state.parent_address_data[1].parent_city.value,
                            parent_postcode: this.state.parent_address_data[1].parent_postcode.value,
                            parent_country: this.state.parent_address_data[1].parent_country.value,
                            parent_address_type: this.state.parent_address_data[1].parent_address_type.value,
                        }
                    ]);
                } else if (this.state.father_details === true && this.state.mother_details === false) {
                    form_data['parent_address_data'] = JSON.stringify([{
                        address_line1: this.state.parent_address_data[0].address_line1.value,
                        address_line2: this.state.parent_address_data[0].address_line2.value,
                        parent_state: this.state.parent_address_data[0].parent_state.value,
                        parent_city: this.state.parent_address_data[0].parent_city.value,
                        parent_postcode: this.state.parent_address_data[0].parent_postcode.value,
                        parent_country: this.state.parent_address_data[0].parent_country.value,
                        parent_address_type: this.state.parent_address_data[0].parent_address_type.value,
                    }]);
                } else if (this.state.father_details === false && this.state.mother_details === true) {
                    form_data['parent_address_data'] = JSON.stringify([{
                        address_line1: this.state.parent_address_data[1].address_line1.value,
                        address_line2: this.state.parent_address_data[1].address_line2.value,
                        parent_state: this.state.parent_address_data[1].parent_state.value,
                        parent_city: this.state.parent_address_data[1].parent_city.value,
                        parent_postcode: this.state.parent_address_data[1].parent_postcode.value,
                        parent_country: this.state.parent_address_data[1].parent_country.value,
                        parent_address_type: this.state.parent_address_data[1].parent_address_type.value,
                    }]);
                }
            }

            if (this.state.address_same_as_parent1.value === true) {
                form_data['parent_address_data'] = JSON.stringify([
                    {
                        address_line1: this.state.parent_address_data[0].address_line1.value,
                        address_line2: this.state.parent_address_data[0].address_line2.value,
                        parent_state: this.state.parent_address_data[0].parent_state.value,
                        parent_city: this.state.parent_address_data[0].parent_city.value,
                        parent_postcode: this.state.parent_address_data[0].parent_postcode.value,
                        parent_country: this.state.parent_address_data[0].parent_country.value,
                        parent_address_type: this.state.parent_address_data[0].parent_address_type.value,
                    },
                    {
                        address_line1: this.state.parent_address_data[0].address_line1.value,
                        address_line2: this.state.parent_address_data[0].address_line2.value,
                        parent_state: this.state.parent_address_data[0].parent_state.value,
                        parent_city: this.state.parent_address_data[0].parent_city.value,
                        parent_postcode: this.state.parent_address_data[0].parent_postcode.value,
                        parent_country: this.state.parent_address_data[0].parent_country.value,
                        parent_address_type: "parent2",
                    }
                ]);
            }

            if (this.state.parent1_as_host.value === true && (!hasParent2Data || this.state.parent2_as_host.value === false)) {
                form_data['parent_as_host'] = JSON.stringify([{
                    parent_type: "parent1", is_host_approved: true,
                    host_relation: "parent1 as host",
                    parent_relation: this.state.add_student_form.parent1_type.value
                }]);
            } else if (this.state.parent1_as_host.value === false && this.state.parent2_as_host.value === false) {
                form_data['parent_as_host'] = JSON.stringify([]);
            } else if (this.state.parent1_as_host.value === false && this.state.parent2_as_host.value === true && hasParent2Data) {
                form_data['parent_as_host'] = JSON.stringify([{
                    parent_type: "parent2", is_host_approved: true,
                    host_relation: "parent2 as host",
                    parent_relation: this.state.add_student_form.parent2_type.value
                }]);
            } else if (this.state.parent1_as_host.value === true && this.state.parent2_as_host.value === true && hasParent2Data) {
                form_data['parent_as_host'] = JSON.stringify([
                    {
                        parent_type: "parent2", is_host_approved: true,
                        host_relation: "parent2 as host",
                        parent_relation: this.state.add_student_form.parent2_type.value
                    },
                    {
                        parent_type: "parent1", is_host_approved: true,
                        host_relation: "parent1 as host",
                        parent_relation: this.state.add_student_form.parent1_type.value
                    }
                ]);
            } else {
                form_data['parent_as_host'] = JSON.stringify([]);
            }

            console.log("📦 form_data being sent to API:", form_data);
            this.setState({ isLoading: true });
            this.props.onCreateStudentAndParents(form_data).then((response) => {
                if (response.success === true) {
                    toast.success(response.message, { position: toast.POSITION.TOP_CENTER });
                    setTimeout(() => {
                        this.setState({ isLoading: false });
                        this.setState({
                            isAuthenticated: true,
                            redirect_url: `/${school_code}/student/student-list`,
                        });
                    }, 500);
                } else {
                    this.setState({ isLoading: false });
                    toast.error(response.message, { position: toast.POSITION.TOP_CENTER });
                }
            });
        } else {
            console.error("🚫 FORM IS INVALID — API call blocked. Check ❌ lines above for the failing fields.");
        }
    };
    onLoadImage = (event) => {
        const file = event.target.files && event.target.files[0];
        if (file) {
            // Check if the file size exceeds 2MB (2 * 1024 * 1024 bytes)
            if (file.size > 2 * 1024 * 1024) {
                this.setState({
                    errorMessage: "The size of image is too large.",
                    imageSrc: null, // Clear any previously loaded image
                });
            } else {
                this.setState({
                    imageSrc: URL.createObjectURL(file),
                    errorMessage: "", // Clear error if the file is valid
                });
            }
        }
        event.target.value = ""; // Reset the input
    };
    checkAndResetParent2Host = () => {
        const { add_student_form, parent2_as_host } = this.state;

        const hasParent2Data = add_student_form.parent2_name.value ||
            add_student_form.parent2_email.value ||
            add_student_form.parent2_phone.value;

        // If parent2 has no data and checkbox was checked, reset it
        if (!hasParent2Data && parent2_as_host.value === false) {
            this.setState({
                parent2_as_host: {
                    ...parent2_as_host,
                    value: true,
                    isChecked: false
                }
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyPress);
    }

    handleKeyPress = (event) => {
        if (event.keyCode === 27) {
            this.setState({ OpenImageModal: false })
        }
    };

    componentWillUnmount() {
        const { imageSrc } = this.state;
        if (imageSrc) {
            URL.revokeObjectURL(imageSrc);
        }
    }



    render() {
        const videoConstraints = {
            width: 1280,
            height: 720,
            facingMode: "user"
        };

        const { add_student_form } = this.state;
        const { showInput } = this.state.add_student_form
        const { parent_address_data } = this.state;
        const { student_age_show } = this.state
        const { host_data, additional_hosts_data = [] } = this.state;
        const { country_id } = this.state

        const { father_details } = this.state
        const { mother_details } = this.state

        const { imageSrc, OpenImageModal, errorMessage } = this.state

        const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
        let curr = new Date();
        curr.setDate(curr.getDate());
        let date = curr.toISOString().substring(0, 10);
        let setEnterUserAge = add_student_form.date_of_birth.value;
        let setNew = new Date(setEnterUserAge)
        let d = new Date();
        const currentyear = d.getFullYear();
        const yearOnly = currentyear - setNew.getFullYear() ? currentyear - setNew.getFullYear() : ``;
        let age_now = d.getFullYear() - setNew.getFullYear();
        let monthsDiff = d.getMonth() - setNew.getMonth();
        let dayDiff = d.getDate() - setNew.getDate();
        if (dayDiff < 0) {
            let tempDate = new Date(d.getFullYear(), d.getMonth() - 1, 0);
            dayDiff += tempDate.getDate();
            monthsDiff--;
            // monthsDiff--;
            // dayDiff += new Date(d.getFullYear(), d.getMonth(), 0).getDate();
        }
        if (monthsDiff < 0 || (monthsDiff === 0 && dayDiff < 0)) {
            age_now--;
            monthsDiff += 12;
        }

        let years = age_now > 0 ? age_now + " year" + (age_now > 1 ? "s" : "") : "";
        let months = monthsDiff > 0 ? monthsDiff + " month" + (monthsDiff > 1 ? "s" : "") : "";
        let year = years && months ? years + " " + months : years + months;

        student_age_show.value = year;
        add_student_form.student_age.value = yearOnly;

        return (
            <React.Fragment>

                {this.state.OpenImageModal &&
                    // <div className="upload-image-outer-div" >
                    //     <span style={{ float: "right" }} className="pointer m-5" onClick={() => this.setState({ OpenImageModal: !this.state.OpenImageModal })}>
                    //         <i class="fas fa-times fa-2x" sixe="xl" style={{ color: "#ffffff", }}></i>

                    //     </span>

                    //     <div className="upload-image-inner-div">
                    //         <AvatarImageCropper
                    //             rootStyle={{ borderRadius: "50%" }}
                    //             cancelBtnStyle={{ display: "none" }}
                    //             apply={this.inputChangeHandlerimage}
                    //             className={"image_crop_style"}
                    //             sliderConStyle={{ margin: "20px", backgroundColor: "none" }}
                    //             applyBtnStyle={{}}
                    //             isBack={true} />
                    //     </div>
                    //     <div className="text-center mt-10">
                    //         <span className="text-white font-weight-bold ">The image maximum size is 2MB. Please upload png/jpg/jpeg image</span>
                    //     </div>
                    // </div>

                    <div className="upload-image-outer-div"  >
                        <span style={{ float: "right" }} className="pointer m-5" onClick={() => this.setState({ OpenImageModal: !this.state.OpenImageModal })}>
                            <i class="fas fa-times fa-2x" sixe="xl" style={{ color: "#ffffff", }}></i>
                        </span>

                        {
                            imageSrc ?
                                <div className="upload-image-dormitory">
                                    <div className="example">
                                        <div className="example__cropper-wrapper">
                                            <Cropper
                                                ref={this.cropperRef}
                                                className="example__cropper"
                                                backgroundClassName="example__cropper-background"
                                                src={imageSrc}
                                            />
                                        </div>
                                        <div className="example__buttons-wrapper">
                                            <button className="example__button" onClick={this.onUpload}>
                                                <input
                                                    ref={this.inputRef}
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={this.onLoadImage}
                                                />
                                                Upload image
                                            </button>
                                            {imageSrc && (
                                                <button className="example__button" onClick={this.onCrop}>
                                                    Submit
                                                </button>
                                            )}
                                        </div>
                                        {OpenImageModal && <div className="modal">Image has been updated!</div>}
                                    </div>
                                </div>
                                : <div className="upload-image-inner-div">
                                    <div className="upload-input-container">
                                        <div
                                            className="upload-input"
                                            onClick={this.onUpload}
                                        >
                                            <div>
                                                <svg viewBox="0 0 24 24" style={{ display: "inline-block", color: "rgb(255, 255, 255)", fill: "currentcolor", height: "32px", width: "32px", userSelect: "none" }}>
                                                    <circle cx="12" cy="12" r="3.2"></circle>
                                                    <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"></path>
                                                </svg>
                                            </div>

                                            <input
                                                ref={this.inputRef}
                                                type="file"
                                                accept="image/*"
                                                onChange={this.onLoadImage}
                                            />
                                            Upload image
                                            {errorMessage && <span className="text-danger font-weight-bold">{errorMessage}</span>}
                                        </div>
                                    </div>
                                </div>
                        }
                        <div className="text-center mt-10 d-flex flex-column align-items-center">
                            <span className="text-white font-weight-bold rounded ">The image maximum size is 2MB. Please upload png/jpg/jpeg image</span>
                        </div>
                    </div>
                }
                {this.state.isAuthenticated ? <Navigate to={this.state.redirect_url} /> : null}
                <div id="kt_body" className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed demo h-100">
                    <div className="d-flex flex-column flex-root h-100">
                        <div className="page d-flex flex-row flex-column-fluid">
                            <Sidebar></Sidebar>

                            <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                                <TopBar></TopBar>
                                <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                                    <div className="post d-flex flex-column-fluid" id="kt_post">
                                        <div id="kt_content_container" className="container-fluid">
                                            <div className="school-edit-form">
                                                <div className="" id="Snapshot">
                                                    <form
                                                        // onSubmit={this.SubmitHandler} 
                                                        autoComplete="off"
                                                    >
                                                        <div className="card mb-5 tabs-outer">
                                                            <div className="card-header position-relative py-0 details-bg">
                                                                <h2 className="card-title  m-0">Student Personal Details</h2>
                                                            </div>
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-4 fv-row mb-5 media-1024">
                                                                        <div className="row">
                                                                            <div className="col-sm-12">
                                                                                <div className="profile-image-out p-0 p-0">
                                                                                    <div className="row justify-content-center">
                                                                                        <div className="col-sm-12">
                                                                                            <img alt="profile" src={add_student_form.student_avatar.thumbnail_image} className="img-fluid" />
                                                                                            {this.state.cam_Start === null ? ""
                                                                                                :
                                                                                                <div className="pb-5 student-photo-by-camera">
                                                                                                    <Picture
                                                                                                        take_photo_by_props={(blob, identifier) => this.take_photo_by_props(blob, identifier)}
                                                                                                        cam_not_available={(value) => this.cam_not_available(value)}
                                                                                                    />
                                                                                                </div>
                                                                                            }


                                                                                            <div className="h-100  wrap-btn-col align-items-center">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-sm btn-outline-primary px-6 rounded-50 "
                                                                                                    onClick={() => this.setState({ OpenImageModal: !this.state.OpenImageModal })}
                                                                                                >
                                                                                                    Upload Image
                                                                                                </button>
                                                                                                <label className="fw-bold px-5">Or</label>
                                                                                                <button className="btn btn-sm btn-primary apply-btn"
                                                                                                    onClick={() => this.setState({ cam_Start: "stream" })}>
                                                                                                    Take Photo
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>


                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                    <div className="col-lg-8 media-1024">
                                                                        <div className="row">
                                                                            <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_student_form.student_first_name.label} </label>
                                                                                <input
                                                                                    type={add_student_form.student_first_name.type}
                                                                                    value={add_student_form.student_first_name.value ? add_student_form.student_first_name.value : ""}
                                                                                    className="form-control"
                                                                                    placeholder={add_student_form.student_first_name.placeholder}
                                                                                    // onChange={(event) => this.inputChangeHandler(event, "student_first_name")}
                                                                                    onChange={(event) => {
                                                                                        // Capitalize the first letter of the input
                                                                                        const value = event.target.value;
                                                                                        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                        this.inputChangeHandler(
                                                                                            { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                            "student_first_name"
                                                                                        );
                                                                                    }}

                                                                                    autoComplete="off"
                                                                                // required
                                                                                />
                                                                                {!add_student_form.student_first_name.valid && add_student_form.student_first_name.onBlur_out ? <div className="error field-error">{add_student_form.student_first_name.error_msg}</div> : ""}
                                                                            </div>

                                                                            <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_student_form.student_last_name.label}</label>
                                                                                <input
                                                                                    type={add_student_form.student_last_name.type}
                                                                                    value={add_student_form.student_last_name.value ? add_student_form.student_last_name.value : ""}
                                                                                    className="form-control"
                                                                                    placeholder={add_student_form.student_last_name.placeholder}
                                                                                    // onChange={(event) => this.inputChangeHandler(event, "student_last_name")}
                                                                                    onChange={(event) => {

                                                                                        // Capitalize the first letter of the input
                                                                                        const value = event.target.value;
                                                                                        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                        this.inputChangeHandler(
                                                                                            { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                            "student_last_name"
                                                                                        );
                                                                                    }}
                                                                                    autoComplete="off"
                                                                                />
                                                                            </div>

                                                                            <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_student_form.preferred_name.label}</label>
                                                                                <input
                                                                                    type={add_student_form.preferred_name.type}
                                                                                    value={add_student_form.preferred_name.value ? add_student_form.preferred_name.value : ""}
                                                                                    className="form-control"
                                                                                    placeholder={add_student_form.preferred_name.placeholder}
                                                                                    // onChange={(event) => this.inputChangeHandler(event, "preferred_name")}
                                                                                    onChange={(event) => {

                                                                                        // Capitalize the first letter of the input
                                                                                        const value = event.target.value;
                                                                                        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                        this.inputChangeHandler(
                                                                                            { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                            "preferred_name"
                                                                                        );
                                                                                    }}
                                                                                    autoComplete="off"
                                                                                />
                                                                                {!add_student_form.preferred_name.valid && add_student_form.preferred_name.onBlur_out ? <div className="error field-error">{add_student_form.preferred_name.error_msg}</div> : ""}
                                                                            </div>

                                                                            <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_student_form.date_of_birth.label}</label>
                                                                                <div className='position-relative'>
                                                                                    <span className='position-absolute apply_adhoc_leave_date_and_time'>
                                                                                        <i class="far fa-calendar-alt"></i>
                                                                                    </span>
                                                                                    <input
                                                                                        id="session-date"
                                                                                        type={add_student_form.date_of_birth.type}
                                                                                        className="form-control"
                                                                                        placeholder={add_student_form.date_of_birth.placeholder}
                                                                                        value={add_student_form.date_of_birth.value !== "" ? add_student_form.date_of_birth.value : ""}
                                                                                        onChange={(event) => this.studentDateOfBirth(event, "date_of_birth")}
                                                                                        autoComplete="off"
                                                                                    // required
                                                                                    />
                                                                                </div>
                                                                                {!add_student_form.date_of_birth.valid && add_student_form.date_of_birth.onBlur_out ? <div className="error field-error">{add_student_form.date_of_birth.error_msg}</div> : ""}
                                                                            </div>

                                                                            <div className="col-lg-4  col-xl-4 fv-row mb-5" >
                                                                                <label className="fw-bold mb-2">{student_age_show.label}</label>
                                                                                <input
                                                                                    style={{ backgroundColor: "#f5f5f5", pointerEvents: "none" }}
                                                                                    type={student_age_show.type}
                                                                                    className="form-control"
                                                                                    value={student_age_show.value ? student_age_show.value : year}
                                                                                    placeholder={student_age_show.placeholder}
                                                                                    autoComplete="off"
                                                                                />
                                                                            </div>

                                                                            <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">Gender * </label>
                                                                                <div className="d-flex">
                                                                                    <label className="cursor-pointer">
                                                                                        <input
                                                                                            type="radio"
                                                                                            id="Gender"
                                                                                            name="Gender"
                                                                                            className="form-check-input me-2 cursor-pointer"
                                                                                            value="male"
                                                                                            onChange={(event) => this.inputChangeHandler(event, "gender")}
                                                                                            autoComplete="off"
                                                                                        />
                                                                                        Male
                                                                                    </label>
                                                                                    <label className="ms-8 cursor-pointer">
                                                                                        <input
                                                                                            type="radio"
                                                                                            id="Gender1"
                                                                                            name="Gender"
                                                                                            className="form-check-input me-2 cursor-pointer"
                                                                                            value="female"
                                                                                            onChange={(event) => this.inputChangeHandler(event, "gender")}
                                                                                            autoComplete="off"
                                                                                        />
                                                                                        Female
                                                                                    </label>
                                                                                </div>
                                                                                {!add_student_form.gender.valid && add_student_form.gender.onBlur_out ? <div className="error field-error">{add_student_form.gender.error_msg}</div> : ""}
                                                                            </div>

                                                                            <div className="col-lg-6  col-xl-6 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_student_form.student_phone.label}</label>
                                                                                <ReactPhoneInput
                                                                                    countryCodeEditable={false}
                                                                                    country={add_student_form.country_code.value ? add_student_form.country_code.value : ""}
                                                                                    value={add_student_form.student_phone.value ? add_student_form.student_phone.value : ""}
                                                                                    onChange={(value, data, e, formattedValue) => this.phoneNumberHandler(value, "student_phone", formattedValue)}
                                                                                    // enableLongNumbers={true}
                                                                                    autoComplete="off"
                                                                                />
                                                                                {!add_student_form.student_phone.valid && add_student_form.student_phone.onBlur_out ? <div className="error field-error">{add_student_form.student_phone.error_msg}</div> : ""}
                                                                            </div>


                                                                            <div style={{ display: 'none' }} className="col-lg-6 col-xl-6 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={showInput}
                                                                                        onChange={this.handleCheckboxChange}
                                                                                    />{" "}
                                                                                    Generate Unique Pin Automatically
                                                                                </label>
                                                                                <input
                                                                                    className="form-control"
                                                                                    placeholder={showInput ? "" : "Enter your unique number"}
                                                                                    type="text"
                                                                                    id="studentNumber"
                                                                                    name="studentNumber"
                                                                                    disabled={showInput} // Disable input if the checkbox is checked
                                                                                    value={add_student_form.unique_pin.value}
                                                                                    onChange={this.handleInputChange}
                                                                                    onFocus={this.handleFocus}
                                                                                    onBlur={this.handleBlur}
                                                                                />
                                                                                {/* Show tooltip if showTooltip = true */}
                                                                                {this.state.showTooltip && (
                                                                                    <div className="tooltip-text">
                                                                                        Format: 3 letters followed by 4 digits (e.g., "abc0001")
                                                                                    </div>
                                                                                )}
                                                                                {!showInput && !add_student_form.unique_pin.valid && add_student_form.unique_pin.onBlur_out ? <div className="error field-error">{add_student_form.unique_pin.error_msg}</div> : ""}
                                                                            </div>
                                                                            {/* <div className="col-lg-4  col-xl-3 fv-row mt-5"> */}
                                                                            <div className="col-lg-6 col-xl-6 fv-row mb-5">
                                                                                {/* <label className="fw-bold mb-2">{add_student_form.kiosk_mode_pin.label}</label> */}
                                                                                <label className="fw-bold mb-2">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={showInput}
                                                                                        onChange={this.handleCheckboxChange}
                                                                                    />{" "}
                                                                                    Generate Kiosk Pin Automatically
                                                                                </label>
                                                                                <div className="position-relative">
                                                                                    <input
                                                                                        type={add_student_form.kiosk_mode_pin.type}
                                                                                        className="form-control appearance-none"
                                                                                        maxLength={6}
                                                                                        min={0}
                                                                                        // placeholder={add_student_form.kiosk_mode_pin.placeholder}
                                                                                        placeholder={showInput ? "" : add_student_form.kiosk_mode_pin.placeholder}
                                                                                        disabled={showInput} // Disable input if the checkbox is checked
                                                                                        onChange={(event) => this.inputChangeHandler(event, "kiosk_mode_pin")}
                                                                                        onKeyDown={(event) => this.validatePinLength(event)}
                                                                                        autoComplete="new-password"
                                                                                    />
                                                                                    {!add_student_form.kiosk_mode_pin.valid && add_student_form.kiosk_mode_pin.onBlur_out ? <div className="error field-error">{add_student_form.kiosk_mode_pin.error_msg}</div> : ""}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-lg-7 col-xl-7 fv-row mb-5">
                                                                                <label className="fw-bold mb-2 ">
                                                                                    {add_student_form.student_email.label}
                                                                                    <Tooltip title="Note:- If genuine address used, student will automatically receive Login instructions to  “VIEW only” Personal & Leave details." placement="top">
                                                                                        <i className="fas fa-question-circle ms-2"></i>
                                                                                    </Tooltip>
                                                                                </label>
                                                                                <div className="d-flex rounded-1" style={{ border: "1px solid #ccccccb8" }}>
                                                                                    <input
                                                                                        style={{ textAlign: "right", paddingRight: "3px", border: "0px" }}
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={add_student_form.student_email.value}
                                                                                        placeholder={add_student_form.student_email.placeholder}
                                                                                        onChange={(event) => this.studentEmailAddresssHandler(event, "student_email")}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                    <div className="h-100  top-0 fw-bold end-0 border border-start-0 rounded-1" style={{ backgroundColor: "#ecf7ff", padding: "7px 5px 8px 7px" }}>
                                                                                        {this.state.school_domain}
                                                                                    </div>
                                                                                </div>
                                                                                {!add_student_form.student_email.valid && add_student_form.student_email.onBlur_out ? <div className="error field-error">{add_student_form.student_email.error_msg}</div> : ""}
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.class_id.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.class_id.options}
                                                                            isOptionDisabled={(option) => option.is_dummy}
                                                                            value={add_student_form.class_id.options.filter(function (option) {
                                                                                return option.value === add_student_form.class_id.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "class_id")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.class_id.valid && add_student_form.class_id.onBlur_out ? <div className="error field-error">{add_student_form.class_id.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.dormitory_id.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.dormitory_id.options}
                                                                            isOptionDisabled={(option) => option.is_dummy}
                                                                            isDisabled={!add_student_form.gender.value}
                                                                            value={add_student_form.dormitory_id.options.filter(function (option) {
                                                                                return option.value === add_student_form.dormitory_id.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "dormitory_id")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.dormitory_id.valid && add_student_form.dormitory_id.onBlur_out ? <div className="error field-error">{add_student_form.dormitory_id.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.campus_name.label} </label>
                                                                        <input
                                                                            type={add_student_form.campus_name.type}
                                                                            value={add_student_form.campus_name.value ? add_student_form.campus_name.value : ""}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.campus_name.placeholder}
                                                                            // onChange={(event) => this.inputChangeHandler(event, "campus_name")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHandler(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "campus_name"
                                                                                );
                                                                            }}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.sporting_house.label} </label>
                                                                        <input
                                                                            type={add_student_form.sporting_house.type}
                                                                            value={add_student_form.sporting_house.value ? add_student_form.sporting_house.value : ""}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.sporting_house.placeholder}
                                                                            // onChange={(event) => this.inputChangeHandler(event, "sporting_house")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHandler(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "sporting_house"
                                                                                );
                                                                            }}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.laundry_number.label} </label>
                                                                        <input
                                                                            type={add_student_form.laundry_number.type}
                                                                            value={add_student_form.laundry_number.value ? add_student_form.laundry_number.value : ""}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.laundry_number.placeholder}
                                                                            onChange={(event) => this.inputChangeHandler(event, "laundry_number")}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.tutor_name.label} </label>
                                                                        <input
                                                                            type={add_student_form.tutor_name.type}
                                                                            value={add_student_form.tutor_name.value ? add_student_form.tutor_name.value : ""}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.tutor_name.placeholder}
                                                                            // onChange={(event) => this.inputChangeHandler(event, "tutor_name")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHandler(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "tutor_name"
                                                                                );
                                                                            }}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.tutor_email.label}</label>
                                                                        <input
                                                                            type={add_student_form.tutor_email.type}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.tutor_email.placeholder}
                                                                            onChange={(event) => this.inputChangeHandler(event, "tutor_email")}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    {/* <div className="col-lg-4  col-xl-3 fv-row mt-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.kiosk_mode_pin.label}</label>
                                                                        <div className="position-relative">
                                                                            <input
                                                                                type={add_student_form.kiosk_mode_pin.type}
                                                                                className="form-control appearance-none"
                                                                                maxLength={6}
                                                                                min={0}
                                                                                placeholder={add_student_form.kiosk_mode_pin.placeholder}
                                                                                onChange={(event) => this.inputChangeHandler(event, "kiosk_mode_pin")}
                                                                                onKeyDown={(event) => this.validatePinLength(event)}
                                                                                autoComplete="new-password"
                                                                            />
                                                                            {!add_student_form.kiosk_mode_pin.valid && add_student_form.kiosk_mode_pin.onBlur_out ? <div className="error field-error">{add_student_form.kiosk_mode_pin.error_msg}</div> : ""}
                                                                        </div>
                                                                    </div> */}
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <input
                                                            type="hidden"
                                                            value={add_student_form.data_status.value ? add_student_form.data_status.value : ""}
                                                        />






                                                        <div className="card mb-5 tabs-outer">
                                                            <div className="card-header position-relative py-0 details-bg">
                                                                <h2 className="card-title  m-0">Student Parent Details</h2>
                                                            </div>
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent1_name.label}</label>
                                                                        <input
                                                                            type={add_student_form.parent1_name.type}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.parent1_name.placeholder}
                                                                            value={add_student_form.parent1_name.value ? add_student_form.parent1_name.value : ""}
                                                                            // onChange={(event) => this.inputChangeHandlerParentNames(event, "parent1_name")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHandlerParentNames(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "parent1_name"
                                                                                );
                                                                            }}
                                                                            readOnly={add_student_form.data_status.value === "null" ? false : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent1_name.valid && add_student_form.parent1_name.onBlur_out ? <div className="error field-error">{add_student_form.parent1_name.error_msg}</div> : ""}
                                                                    </div>
                                                                    <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent1_type.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.parent1_type.options}
                                                                            value={add_student_form.parent1_type.options.filter(function (option) {
                                                                                return option.value === add_student_form.parent1_type.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "parent1_type")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent1_type.valid && add_student_form.parent1_type.onBlur_out ?
                                                                            <div className="error field-error">{add_student_form.parent1_type.error_msg}</div> : ""}
                                                                    </div>
                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent2_name.label}</label>
                                                                        <input
                                                                            type={add_student_form.parent2_name.type}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.parent2_name.placeholder}
                                                                            value={add_student_form.parent2_name.value ? add_student_form.parent2_name.value : ""}
                                                                            // onChange={(event) => this.inputChangeHandlerParentNames(event, "parent2_name")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHandlerParentNames(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "parent2_name"
                                                                                );
                                                                            }}
                                                                            readOnly={add_student_form.data_status.value === "null" ? false : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent2_name.valid && add_student_form.parent2_name.onBlur_out ? <div className="error field-error">{add_student_form.parent2_name.error_msg}</div> : ""}
                                                                    </div>
                                                                    <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent2_type.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.parent2_type.options}
                                                                            value={add_student_form.parent2_type.options.filter(function (option) {
                                                                                return option.value === add_student_form.parent2_type.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "parent2_type")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent2_type.valid && add_student_form.parent2_type.onBlur_out ?
                                                                            <div className="error field-error">{add_student_form.parent2_type.error_msg}</div> : ""}
                                                                    </div>
                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent1_email.label}</label>
                                                                        <input
                                                                            type={add_student_form.parent1_email.type}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.parent1_email.placeholder}
                                                                            onChange={(event) => this.parentEmailHandler(event, "parent1_email")}
                                                                            value={add_student_form.parent1_email.value ? add_student_form.parent1_email.value : ""}
                                                                        // autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent1_email.valid && add_student_form.parent1_email.onBlur_out ? <div className="error field-error">{add_student_form.parent1_email.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent2_email.label}</label>
                                                                        <input
                                                                            type={add_student_form.parent2_email.type}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.parent2_email.placeholder}
                                                                            value={add_student_form.parent2_email.value ? add_student_form.parent2_email.value : ""}
                                                                            onChange={(event) => this.parentEmailHandler(event, "parent2_email")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent2_email.valid && add_student_form.parent2_email.onBlur_out ? <div className="error field-error">{add_student_form.parent2_email.error_msg}</div> : ""}
                                                                    </div>


                                                                    {/* <div className="col-lg-12">
                                                                        <div className="d-flex justify-content-between gap-5">
                                                                            <h6 className="mb-0"> parent1 Address </h6>
                                                                            <div className="d-flex align-items-center">
                                                                                <label className="fw-bold d-flex align-items-center"> <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input me-4"
                                                                                    value={this.state.parent1_as_host.value}
                                                                                    onChange={(event) => this.inputParentCheckbox(event, "parent1_as_host")}
                                                                                    autoComplete="off"
                                                                                /> 
                                                                                Automatically Add parent1 as Host
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <hr />
                                                                    </div> */}

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[0]?.address_line1?.label}</label>
                                                                        <input
                                                                            type={parent_address_data[0].address_line1.type}
                                                                            className="form-control"
                                                                            placeholder={parent_address_data[0].address_line1.placeholder}
                                                                            value={parent_address_data[0].address_line1.value ? parent_address_data[0].address_line1.value : ""}
                                                                            // onChange={(event) => this.parentAddressHandler(event, 0, "address_line1")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.parentAddressHandler(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    0, "address_line1"
                                                                                );
                                                                            }}
                                                                            readOnly={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[0].address_line1.valid && parent_address_data[0].address_line1.onBlur_out ? <div className="error field-error">{parent_address_data[0].address_line1.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[0].address_line2.label}</label>
                                                                        <input
                                                                            type={parent_address_data[0].address_line2.type}
                                                                            className="form-control"
                                                                            placeholder={parent_address_data[0].address_line2.placeholder}
                                                                            value={parent_address_data[0].address_line2.value ? parent_address_data[0].address_line2.value : ""}
                                                                            // onChange={(event) => this.parentAddressHandler(event, 0, "address_line2")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.parentAddressHandler(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    0, "address_line2"
                                                                                );
                                                                            }}
                                                                            readOnly={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[0].address_line2.valid && parent_address_data[0].address_line2.onBlur_out ? <div className="error field-error">{parent_address_data[0].address_line2.error_msg}</div> : ""}
                                                                    </div>

                                                                    {/* ///////////////////////////// parent1 country , state , city , postal code ,////////////////////////////////////// */}

                                                                    <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[0].parent_country.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={country_id.options}
                                                                            value={country_id.options.find((option) => option.label === parent_address_data[0].parent_country.value)}
                                                                            onChange={(newValue) => this.selectParentCountry(newValue, 0, "parent_country")}
                                                                        />
                                                                        {!parent_address_data[0].parent_country.valid && parent_address_data[0].parent_country.onBlur_out ? <div className="error field-error">{parent_address_data[0].parent_country.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[0].parent_state.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={parent_address_data[0].parent_state.options}
                                                                            value={parent_address_data[0].parent_state.options.find((option) => option.label === parent_address_data[0].parent_state.value)}
                                                                            onChange={(newValue) => this.selectParentCountry(newValue, 0, "parent_state")}
                                                                            readOnly={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[1].parent_city.valid && parent_address_data[1].parent_city.onBlur_out ? <div className="error field-error">{parent_address_data[1].parent_city.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-2  col-xl fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[0].parent_city.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={parent_address_data[0].parent_city.options}
                                                                            value={parent_address_data[0].parent_city.options.find((option) => option.label === parent_address_data[0].parent_city.value)}
                                                                            onChange={(newValue) => this.selectParentCountry(newValue, 0, "parent_city")}
                                                                            readOnly={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[1].parent_city.valid && parent_address_data[1].parent_city.onBlur_out ? <div className="error field-error">{parent_address_data[1].parent_city.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-2  col-xl fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[0].parent_postcode.label}</label>
                                                                        <input
                                                                            type={parent_address_data[0].parent_postcode.type}
                                                                            className="form-control"
                                                                            placeholder={parent_address_data[0].parent_postcode.placeholder}
                                                                            value={parent_address_data[0].parent_postcode.value ? parent_address_data[0].parent_postcode.value : ""}
                                                                            onChange={(event) => this.parentAddressHandler(event, 0, "parent_postcode")}
                                                                            readOnly={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[0].parent_postcode.valid && parent_address_data[0].parent_postcode.onBlur_out ? <div className="error field-error">{parent_address_data[0].parent_postcode.error_msg}</div> : ""}
                                                                    </div>

                                                                    {/* //////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent1_phone.label}</label>
                                                                        <ReactPhoneInput
                                                                            countryCodeEditable={false}
                                                                            country={parent_address_data[0].parent_country.country_code === "" ? add_student_form.country_code.value : parent_address_data[0]?.parent_country.country_code?.toLocaleLowerCase()}
                                                                            value={add_student_form.parent1_phone.value ? add_student_form.parent1_phone.value : ""}
                                                                            onChange={(value, data, e, formattedValue) => this.phoneNumberHandler(value, "parent1_phone", formattedValue)}
                                                                            disabled={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            // enableLongNumbers={true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent1_phone.valid && add_student_form.parent1_phone.onBlur_out ? <div className="error field-error">{add_student_form.parent1_phone.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent1_work_phone.label}</label>
                                                                        <ReactPhoneInput
                                                                            countryCodeEditable={false}
                                                                            country={parent_address_data[0].parent_country.country_code === "" ? add_student_form.country_code.value : parent_address_data[0]?.parent_country.country_code?.toLocaleLowerCase()}
                                                                            value={add_student_form.parent1_work_phone.value ? add_student_form.parent1_work_phone.value : ""}
                                                                            onChange={(value, data, e, formattedValue) => this.phoneNumberHandler(value, "parent1_work_phone", formattedValue)}
                                                                            disabled={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            // disabled={add_student_form.data_status.value === "null" ? false : true}
                                                                            // enableLongNumbers={true}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent1_home_phone.label}</label>
                                                                        <ReactPhoneInput
                                                                            countryCodeEditable={false}
                                                                            country={parent_address_data[0].parent_country.country_code === "" ? add_student_form.country_code.value : parent_address_data[0]?.parent_country.country_code?.toLocaleLowerCase()}
                                                                            value={add_student_form.parent1_home_phone.value ? add_student_form.parent1_home_phone.value : ""}
                                                                            onChange={(value, data, e, formattedValue) => this.phoneNumberHandler(value, "parent1_home_phone", formattedValue)}
                                                                            disabled={father_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            // enableLongNumbers={true}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>





                                                                    <div className="col-lg-12">
                                                                        <div className="d-flex justify-content-between gap-5">
                                                                            <div className="d-flex align-items-center gap-10">
                                                                                <h6 className="mb-0">Parent 2 Address  </h6>
                                                                                <label className="fw-bold d-flex align-items-center">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input me-4"
                                                                                        value={this.state.address_same_as_parent1.value}
                                                                                        onChange={(event) => this.inputParentCheckbox(event, "address_same_as_parent1")}
                                                                                        autoComplete="off"
                                                                                        disabled={this.state.father_details === true && this.state.mother_details === true ? false : true}
                                                                                    />
                                                                                    If Parent 2 are same as parent1
                                                                                </label>
                                                                            </div>
                                                                            {/* 
                                                                            <div className="d-flex align-items-center">
                                                                                <label className="fw-bold d-flex align-items-center">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input me-4"
                                                                                        value={this.state.parent2_as_host.value}
                                                                                        onChange={(event) => this.inputParentCheckbox(event, "parent2_as_host")}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                    Automatically Add parent2 as Host
                                                                                </label>
                                                                            </div> */}
                                                                        </div>
                                                                        <hr />
                                                                    </div>












                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[1].address_line1.label}</label>
                                                                        <input
                                                                            type={parent_address_data[1].address_line1.type}
                                                                            className="form-control"
                                                                            placeholder={parent_address_data[1].address_line1.placeholder}
                                                                            value={parent_address_data[1].address_line1.value ? parent_address_data[1].address_line1.value : ""}
                                                                            // onChange={(event) => this.parentAddressHandler(event, 1, "address_line1")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.parentAddressHandler(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    1, "address_line1"
                                                                                );
                                                                            }}
                                                                            readOnly={mother_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[1].address_line1.valid && parent_address_data[1].address_line1.onBlur_out ? <div className="error field-error">{parent_address_data[1].address_line1.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[1].address_line2.label}</label>
                                                                        <input
                                                                            type={parent_address_data[1].address_line2.type}
                                                                            className="form-control"
                                                                            placeholder={parent_address_data[1].address_line2.placeholder}
                                                                            value={parent_address_data[1].address_line2.value ? parent_address_data[1].address_line2.value : ""}
                                                                            // onChange={(event) => this.parentAddressHandler(event, 1, "address_line2")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.parentAddressHandler(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    1, "address_line2"
                                                                                );
                                                                            }}
                                                                            readOnly={mother_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[1].address_line2.valid && parent_address_data[1].address_line2.onBlur_out ? <div className="error field-error">{parent_address_data[1].address_line2.error_msg}</div> : ""}
                                                                    </div>

                                                                    {/* ///////////////////////////// parent2 country , state , city , postal code ,////////////////////////////////////// */}

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[1].parent_country.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={country_id.options}
                                                                            value={country_id.options.find((option) => option.label === parent_address_data[1].parent_country.value)}
                                                                            onChange={(newValue) => this.selectParentCountry(newValue, 1, "parent_country")}
                                                                        />
                                                                        {!parent_address_data[1].parent_country.valid && parent_address_data[1].parent_country.onBlur_out ? <div className="error field-error">{parent_address_data[1].parent_country.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[1].parent_state.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={parent_address_data[1].parent_state.options}
                                                                            value={parent_address_data[1].parent_state.options.find((option) => option.label === parent_address_data[1].parent_state.value)}
                                                                            onChange={(newValue) => this.selectParentCountry(newValue, 1, "parent_state")}
                                                                        />
                                                                        {!parent_address_data[1].parent_city.valid && parent_address_data[1].parent_city.onBlur_out ? <div className="error field-error">{parent_address_data[1].parent_city.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-2  col-xl fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[1].parent_city.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={parent_address_data[1].parent_city.options}
                                                                            value={parent_address_data[1].parent_city.options.find((option) => option.label === parent_address_data[1].parent_city.value)}
                                                                            onChange={(newValue) => this.selectParentCountry(newValue, 1, "parent_city")}
                                                                        />
                                                                        {!parent_address_data[1].parent_city.valid && parent_address_data[1].parent_city.onBlur_out ? <div className="error field-error">{parent_address_data[1].parent_city.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-2  col-xl fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{parent_address_data[1].parent_postcode.label}</label>
                                                                        <input
                                                                            type={parent_address_data[1].parent_postcode.type}
                                                                            className="form-control"
                                                                            placeholder={parent_address_data[1].parent_postcode.placeholder}
                                                                            value={parent_address_data[1].parent_postcode.value ? parent_address_data[1].parent_postcode.value : ""}
                                                                            onChange={(event) => this.parentAddressHandler(event, 1, "parent_postcode")}
                                                                            readOnly={mother_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!parent_address_data[1].parent_postcode.valid && parent_address_data[1].parent_postcode.onBlur_out ? <div className="error field-error">{parent_address_data[1].parent_postcode.error_msg}</div> : ""}
                                                                    </div>


                                                                    {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}



                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent2_phone.label}</label>
                                                                        <ReactPhoneInput
                                                                            countryCodeEditable={false}
                                                                            country={parent_address_data[1].parent_country.country_code === "" ? add_student_form.country_code.value : parent_address_data[1]?.parent_country?.country_code?.toLocaleLowerCase()}
                                                                            value={add_student_form.parent2_phone.value ? add_student_form.parent2_phone.value : ""}
                                                                            onChange={(value, data, e, formattedValue) => this.phoneNumberHandler(value, "parent2_phone", formattedValue)}
                                                                            disabled={mother_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            // enableLongNumbers={true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.parent2_phone.valid && add_student_form.parent2_phone.onBlur_out ? <div className="error field-error">{add_student_form.parent2_phone.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent2_home_phone.label}</label>
                                                                        <ReactPhoneInput
                                                                            countryCodeEditable={false}
                                                                            country={parent_address_data[1].parent_country.country_code === "" ? add_student_form.country_code.value : parent_address_data[1]?.parent_country?.country_code?.toLocaleLowerCase()}
                                                                            value={add_student_form.parent2_home_phone.value ? add_student_form.parent2_home_phone.value : ""}
                                                                            onChange={(value, data, e, formattedValue) => this.phoneNumberHandler(value, "parent2_home_phone", formattedValue)}
                                                                            disabled={mother_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            // enableLongNumbers={true}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.parent2_work_phone.label}</label>
                                                                        <ReactPhoneInput
                                                                            countryCodeEditable={false}
                                                                            country={parent_address_data[1].parent_country.country_code === "" ? add_student_form.country_code.value : parent_address_data[1]?.parent_country?.country_code?.toLocaleLowerCase()}
                                                                            value={add_student_form.parent2_work_phone.value ? add_student_form.parent2_work_phone.value : ""}
                                                                            onChange={(value, data, e, formattedValue) => this.phoneNumberHandler(value, "parent2_work_phone", formattedValue)}
                                                                            disabled={mother_details === true ? (add_student_form.data_status.value === "null" ? false : true) : true}
                                                                            // enableLongNumbers={true}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>




                                                                    {/* <div className="col-lg-12 fv-row mb-5">
                                                                        <label className="fw-bold mb-2 py-5">{add_student_form.salutation.label}</label>
                                                                        <input
                                                                            type={add_student_form.salutation.type}
                                                                            className="form-control"
                                                                            placeholder={add_student_form.salutation.placeholder}
                                                                            onChange={(event) => this.inputChangeHandler(event, "salutation")}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>*/}
                                                                </div>
                                                            </div>
                                                        </div>









                                                        <div className="card mb-5 tabs-outer">
                                                            <div className="card-header position-relative py-0 details-bg">
                                                                <h2 className="card-title  m-0">Host Details</h2>
                                                                <label className="fw-bold d-flex align-items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input me-4"
                                                                        value={host_data.is_host_approved.value}
                                                                        defaultChecked={host_data.is_host_approved.value}
                                                                        onChange={(event) => this.inputChangehostCheckbox(event)}
                                                                        autoComplete="off"
                                                                    />
                                                                    {host_data.is_host_approved.label}
                                                                </label>
                                                            </div>
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.host_name.label}</label>
                                                                        <input
                                                                            type={host_data.host_name.type}
                                                                            className="form-control"
                                                                            placeholder={host_data.host_name.placeholder}
                                                                            value={host_data.host_name.value}
                                                                            // onChange={(event) => this.inputChangeHost(event, "host_name")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHost(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "host_name"
                                                                                );
                                                                            }}
                                                                            readOnly={host_data.data_status.value === "null" ? false : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!host_data.host_name.valid && host_data.host_name.onBlur_out ? <div className="error field-error">{host_data.host_name.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.host_relation.label}</label>
                                                                        <input
                                                                            type={host_data?.host_relation?.type}
                                                                            className="form-control"
                                                                            placeholder={host_data?.host_relation.placeholder}
                                                                            value={host_data?.host_relation.value}
                                                                            // onChange={(event) => this.inputChangeHost(event, "host_relation")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHost(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "host_relation"
                                                                                );
                                                                            }}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!host_data.host_relation?.valid && host_data?.host_relation.onBlur_out ? <div className="error field-error">{host_data?.host_relation.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.host_email.label}</label>
                                                                        <input
                                                                            type={host_data.host_email.type}
                                                                            className="form-control"
                                                                            placeholder={host_data.host_email.placeholder}
                                                                            onChange={(event) => this.inputChangeHost(event, "host_email")}
                                                                            value={host_data.host_email.value}
                                                                            // readOnly={host_data.data_status.value === "null" ? false : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!host_data.host_email.valid && host_data.host_email.onBlur_out ? <div className="error field-error">{host_data.host_email.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.host_contact.label}</label>
                                                                        <ReactPhoneInput
                                                                            countryCodeEditable={false}
                                                                            country={add_student_form.country_code.value ? add_student_form.country_code.value : ""}
                                                                            value={host_data.host_contact.value ? host_data.host_contact.value : ""}
                                                                            onChange={(event) => this.inputChangeHost(event, "host_contact")}
                                                                            disabled={host_data.data_status.value === "null" ? false : true}
                                                                            // enableLongNumbers={true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!host_data.host_contact.valid && host_data.host_contact.onBlur_out ? <div className="error field-error">{host_data.host_contact.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.host_address.label}</label>
                                                                        <input
                                                                            type={host_data.host_address.type}
                                                                            className="form-control"
                                                                            placeholder={host_data.host_address.placeholder}
                                                                            value={host_data.host_address.value}
                                                                            // onChange={(event) => this.inputChangeHost(event, "host_address")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHost(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "host_address"
                                                                                );
                                                                            }}
                                                                            readOnly={host_data.data_status.value === "null" ? false : true}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!host_data.host_address.valid && host_data.host_address.onBlur_out ? <div className="error field-error">{host_data.host_address.error_msg}</div> : ""}
                                                                    </div>
                                                                    {/* <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.first_point_contact.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.first_point_contact.options}
                                                                            value={add_student_form.first_point_contact.options.filter(function (option) {
                                                                                return option.value === add_student_form.first_point_contact.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "first_point_contact", "weekend_day from value")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.first_point_contact.valid && add_student_form.first_point_contact.onBlur_out ? <div className="error field-error">{add_student_form.first_point_contact.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-3 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.first_point_email.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.first_point_email.options}
                                                                            value={add_student_form.first_point_email.options.filter(function (option) {
                                                                                return option.value === add_student_form.first_point_email.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "first_point_email", "weekend_day")}
                                                                            autoComplete="new-password"
                                                                        />
                                                                        {!add_student_form.first_point_email.valid && add_student_form.first_point_email.onBlur_out ? <div className="error field-error">{add_student_form.first_point_email.error_msg}</div> : ""}
                                                                    </div> */}
                                                                    {additional_hosts_data.map((add_host, index) => (
                                                                        <div className="row mt-4" key={index}>
                                                                            <hr></hr>
                                                                            <div className="col-md-12 d-flex justify-content-between align-items-center mb-3">
                                                                                <h5 className="mb-0 text-primary">Additional Host {index + 1}</h5>
                                                                                <div className="d-flex align-items-center">
                                                                                    <label className="fw-bold d-flex align-items-center me-4">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input me-2"
                                                                                            value={add_host.is_host_approved.value}
                                                                                            checked={add_host.is_host_approved.value}
                                                                                            onChange={(event) => this.inputChangeAdditionalHostCheckbox(event, index)}
                                                                                            autoComplete="off"
                                                                                        />
                                                                                        {add_host.is_host_approved.label}
                                                                                    </label>
                                                                                    <button type="button" className="btn btn-sm btn-danger" onClick={() => this.removeAdditionalHost(index)}>
                                                                                        <i className="fas fa-trash"></i> Remove
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_host.host_name.label}</label>
                                                                                <input
                                                                                    type={add_host.host_name.type}
                                                                                    className="form-control"
                                                                                    placeholder={add_host.host_name.placeholder}
                                                                                    value={add_host.host_name.value}
                                                                                    onChange={(event) => {
                                                                                        const value = event.target.value;
                                                                                        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                        this.inputChangeAdditionalHost({ ...event, target: { ...event.target, value: capitalizedValue } }, index, "host_name");
                                                                                    }}
                                                                                    readOnly={add_host.data_status.value === "null" ? false : true}
                                                                                    autoComplete="off"
                                                                                />
                                                                                {!add_host.host_name.valid && add_host.host_name.onBlur_out && <div className="error field-error">{add_host.host_name.error_msg}</div>}
                                                                            </div>

                                                                            <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_host.host_relation?.label}</label>
                                                                                <input
                                                                                    type={add_host.host_relation?.type}
                                                                                    className="form-control"
                                                                                    placeholder={add_host.host_relation?.placeholder}
                                                                                    value={add_host.host_relation?.value}
                                                                                    onChange={(event) => {
                                                                                        const value = event.target.value;
                                                                                        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                        this.inputChangeAdditionalHost({ ...event, target: { ...event.target, value: capitalizedValue } }, index, "host_relation");
                                                                                    }}
                                                                                    autoComplete="off"
                                                                                />
                                                                                {!add_host.host_relation?.valid && add_host.host_relation?.onBlur_out && <div className="error field-error">{add_host.host_relation.error_msg}</div>}
                                                                            </div>

                                                                            <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_host.host_email.label}</label>
                                                                                <input
                                                                                    type={add_host.host_email.type}
                                                                                    className="form-control"
                                                                                    placeholder={add_host.host_email.placeholder}
                                                                                    value={add_host.host_email.value}
                                                                                    onChange={(event) => this.inputChangeAdditionalHost(event, index, "host_email")}
                                                                                    autoComplete="off"
                                                                                />
                                                                                {!add_host.host_email.valid && add_host.host_email.onBlur_out && <div className="error field-error">{add_host.host_email.error_msg}</div>}
                                                                            </div>

                                                                            <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_host.host_contact.label}</label>
                                                                                <ReactPhoneInput
                                                                                    countryCodeEditable={false}
                                                                                    country={add_student_form.country_code.value || ""}
                                                                                    value={add_host.host_contact.value || ""}
                                                                                    onChange={(event) => this.inputChangeAdditionalHost(event, index, "host_contact")}
                                                                                    disabled={add_host.data_status.value === "null" ? false : true}
                                                                                    autoComplete="off"
                                                                                />
                                                                                {!add_host.host_contact.valid && add_host.host_contact.onBlur_out && <div className="error field-error">{add_host.host_contact.error_msg}</div>}
                                                                            </div>

                                                                            <div className="col-lg-4 col-xl-3 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">{add_host.host_address.label}</label>
                                                                                <input
                                                                                    type={add_host.host_address.type}
                                                                                    className="form-control"
                                                                                    placeholder={add_host.host_address.placeholder}
                                                                                    value={add_host.host_address.value}
                                                                                    onChange={(event) => {
                                                                                        const value = event.target.value;
                                                                                        const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                        this.inputChangeAdditionalHost({ ...event, target: { ...event.target, value: capitalizedValue } }, index, "host_address");
                                                                                    }}
                                                                                    readOnly={add_host.data_status.value === "null" ? false : true}
                                                                                    autoComplete="off"
                                                                                />
                                                                                {!add_host.host_address.valid && add_host.host_address.onBlur_out && <div className="error field-error">{add_host.host_address.error_msg}</div>}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    {/* <hr></hr> */}
                                                                    <div className="col-md-12 mt-1 mb-5 text-end">
                                                                        <button type="button" className="btn btn-sm btn-primary" onClick={this.addAdditionalHost}>+ Add Another Host</button>
                                                                    </div>

                                                                    <div className="col-md-12">
                                                                        <h6 className="mb-0">Remarks</h6>
                                                                        <hr />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.remark_parents.label}</label>
                                                                        <textarea
                                                                            type={host_data.remark_parents.type}
                                                                            className="form-control h-100px"
                                                                            placeholder="Parent's remarks"
                                                                            value={host_data.remark_parents.value}
                                                                            // onChange={(event) => this.inputChangeHost(event, "remark_parents")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHost(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "remark_parents"
                                                                                );
                                                                            }}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.remark_boarding.label}</label>
                                                                        <textarea
                                                                            type={host_data.remark_boarding.type}
                                                                            className="form-control h-100px"
                                                                            placeholder="Boarding's remarks"
                                                                            value={host_data.remark_boarding.value}
                                                                            // onChange={(event) => this.inputChangeHost(event, "remark_boarding")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHost(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "remark_boarding"
                                                                                );
                                                                            }}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{host_data.remark_host.label}</label>
                                                                        <textarea
                                                                            type={host_data.remark_host.type}
                                                                            className="form-control h-100px"
                                                                            placeholder={host_data.remark_host.placeholder}
                                                                            value={host_data.remark_host.value}
                                                                            // onChange={(event) => this.inputChangeHost(event, "remark_host")}
                                                                            onChange={(event) => {

                                                                                // Capitalize the first letter of the input
                                                                                const value = event.target.value;
                                                                                const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                this.inputChangeHost(
                                                                                    { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                    "remark_host"
                                                                                );
                                                                            }}
                                                                            autoComplete="off"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>










                                                        <div className="card mb-5 tabs-outer">
                                                            <div className="card-header position-relative py-0 details-bg">
                                                                <h2 className="card-title  m-0">Permission’s</h2>
                                                            </div>
                                                            <div className="card-body add-new-schools p-6">
                                                                <div className="row permission-check-wrap">
                                                                    <div className="col-lg-4 col-xl-4 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.first_point_contact.label}</label>
                                                                        {/* <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.first_point_contact.options}
                                                                            value={add_student_form.first_point_contact.options.filter(function (option) {
                                                                                return option.value === add_student_form.first_point_contact.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "first_point_contact", "weekend_day from value")}
                                                                            autoComplete="off"
                                                                        /> */}
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.first_point_contact.options.filter(option => {
                                                                                // Show "Parent 2 Contact Number" only if parent2_phone has a value
                                                                                if (option.value === "p2") {
                                                                                    return add_student_form.parent2_phone.value !== "";
                                                                                }
                                                                                return true; // Show all other options
                                                                            })}
                                                                            value={add_student_form.first_point_contact.options.filter(function (option) {
                                                                                return option.value === add_student_form.first_point_contact.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "first_point_contact", "weekend_day from value")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.first_point_contact.valid && add_student_form.first_point_contact.onBlur_out ? <div className="error field-error">{add_student_form.first_point_contact.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.first_point_email.label}</label>
                                                                        {/* <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.first_point_email.options}
                                                                            value={add_student_form.first_point_email.options.filter(function (option) {
                                                                                return option.value === add_student_form.first_point_email.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "first_point_email", "weekend_day")}
                                                                            autoComplete="new-password"
                                                                        /> */}
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.first_point_email.options.filter(option => {
                                                                                // Show "Parent 2 Email Address" only if parent2_email has a value
                                                                                if (option.value === "p2") {
                                                                                    return add_student_form.parent2_email.value !== "";
                                                                                }
                                                                                return true; // Show all other options
                                                                            })}
                                                                            value={add_student_form.first_point_email.options.filter(function (option) {
                                                                                return option.value === add_student_form.first_point_email.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "first_point_email", "weekend_day")}
                                                                            autoComplete="new-password"
                                                                        />
                                                                        {!add_student_form.first_point_email.valid && add_student_form.first_point_email.onBlur_out ? <div className="error field-error">{add_student_form.first_point_email.error_msg}</div> : ""}
                                                                    </div>

                                                                    <div className="col-lg-4  col-xl-4 fv-row mb-5">
                                                                        <label className="fw-bold mb-2">{add_student_form.primary_parent.label}</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={add_student_form.primary_parent.options.filter(option => {
                                                                                // Show "Parent 2" only if parent2 details have been added
                                                                                if (option.value === "p2") {
                                                                                    return !!(add_student_form.parent2_name.value || add_student_form.parent2_email.value || add_student_form.parent2_phone.value);
                                                                                }
                                                                                return true; // Show all other options
                                                                            })}
                                                                            value={add_student_form.primary_parent.options.filter(function (option) {
                                                                                return option.value === add_student_form.primary_parent.value;
                                                                            })}
                                                                            onChange={(newValue) => this.selectHandleChange(newValue, "primary_parent")}
                                                                            autoComplete="off"
                                                                        />
                                                                        {!add_student_form.primary_parent.valid && add_student_form.primary_parent.onBlur_out ? <div className="error field-error">{add_student_form.primary_parent.error_msg}</div> : ""}
                                                                    </div>
                                                                    {/* <div className="col-lg-3 fv-row">
                                                                        <label className="fw-bold d-flex">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="per"
                                                                                name="permission"
                                                                                className="form-check-input cursor-pointer"
                                                                                value="true"
                                                                                onChange={(event) => this.inputChangeHandler(event, "display_image_required")}
                                                                                autoComplete="off"
                                                                            />
                                                                            Want to display Image
                                                                        </label>
                                                                        {!add_student_form.display_image_required.valid && add_student_form.display_image_required.onBlur_out ? <div className="error field-error">{add_student_form.display_image_required.error_msg}</div> : ""}
                                                                    </div> */}


                                                                    <div className="col-lg-3 fv-row">
                                                                        <label className="fw-bold d-flex">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                value={add_student_form.show_parent_detail_app.value}
                                                                                defaultChecked={add_student_form.show_parent_detail_app.value}
                                                                                onChange={(event) => this.inputChangeHandlerCheckbox(event, "show_parent_detail_app")}
                                                                                autoComplete="off"
                                                                            />
                                                                            {add_student_form.show_parent_detail_app.label}
                                                                        </label>
                                                                    </div>

                                                                    <div className="col-lg-3 fv-row">
                                                                        <label className="fw-bold d-flex">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                value={add_student_form.withdraw_leave.value}
                                                                                defaultChecked={add_student_form.withdraw_leave.value}
                                                                                onChange={(event) => this.inputChangeHandlerCheckbox(event, "withdraw_leave")}
                                                                            />
                                                                            {add_student_form.withdraw_leave.label}
                                                                        </label>
                                                                    </div>

                                                                    <div className="col-lg-3 fv-row">
                                                                        <label className="fw-bold d-flex">
                                                                            <input
                                                                                type="checkbox"
                                                                                disabled
                                                                                className="form-check-input custom-disabled-checkbox"
                                                                                value={add_student_form.permitted_student_app_signout.value}
                                                                                defaultChecked={add_student_form.permitted_student_app_signout.value}
                                                                                onChange={(event) => this.inputChangeHandlerCheckbox(event, "permitted_student_app_signout")}
                                                                                autoComplete="off"
                                                                            />
                                                                            {add_student_form.permitted_student_app_signout.label}
                                                                        </label>
                                                                    </div>
                                                                </div>



                                                                <div className="row mt-4 permission-check-wrap">
                                                                    <div className="col-lg-3">
                                                                        <label className="fw-bold d-flex">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                value={this.state.parent1_as_host.value}
                                                                                onChange={(event) => this.inputParentCheckbox(event, "parent1_as_host")}
                                                                                autoComplete="off"
                                                                            />
                                                                            Exclude parent1 As Host
                                                                        </label>
                                                                    </div>
                                                                    {(add_student_form.parent2_name.value ||
                                                                        add_student_form.parent2_email.value ||
                                                                        add_student_form.parent2_phone.value) && (
                                                                            <div className="col-lg-3">
                                                                                <label className="fw-bold d-flex">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        value={this.state.parent2_as_host.value}
                                                                                        onChange={(event) => this.inputParentCheckbox(event, "parent2_as_host")}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                    Exclude parent2 As Host
                                                                                </label>
                                                                            </div>
                                                                        )}
                                                                    {/* <div className="col-lg-3">
                                                                        <label className="fw-bold d-flex">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                value={this.state.parent2_as_host.value}
                                                                                onChange={(event) => this.inputParentCheckbox(event, "parent2_as_host")}
                                                                                autoComplete="off"
                                                                            />
                                                                            Exclude parent2 As Host
                                                                        </label>
                                                                    </div> */}

                                                                    <div className="col-lg-6">
                                                                        <label className="fw-bold d-flex">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                value={add_student_form.allergy_unauth_access.value}
                                                                                defaultChecked={add_student_form.allergy_unauth_access.value}
                                                                                onChange={(event) => this.inputChangeHandlerCheckbox(event, "allergy_unauth_access")}
                                                                                autoComplete="off"
                                                                            />
                                                                            {add_student_form.allergy_unauth_access.label}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12 fv-row mt-5">
                                                                    <label class="fw-bold mb-2">Display options?</label>
                                                                    <div className="d-flex gap-5">
                                                                        <label className="fw-bold d-flex align-items-center gap-2">
                                                                            <input
                                                                                type="radio"
                                                                                id="per"
                                                                                name="permission"
                                                                                className="form-check-input cursor-pointer"
                                                                                value="true"
                                                                                onChange={(event) => this.inputChangeHandler(event, "display_image_required")}
                                                                                autoComplete="off"
                                                                            />
                                                                            Display photo on system
                                                                        </label>
                                                                        <label className="fw-bold d-flex mb-2 align-items-center gap-2">
                                                                            <input
                                                                                type="radio"
                                                                                id="per"
                                                                                name="permission"
                                                                                className="form-check-input cursor-pointer"
                                                                                value="false"
                                                                                onChange={(event) => this.inputChangeHandler(event, "display_image_required")}
                                                                                autoComplete="off"
                                                                            />
                                                                            Display shadow on system
                                                                        </label>
                                                                    </div>
                                                                    {!add_student_form.display_image_required.valid && add_student_form.display_image_required.onBlur_out ? <div className="error field-error">{add_student_form.display_image_required.error_msg}</div> : ""}
                                                                </div>
                                                            </div>
                                                        </div>






                                                        <div className="card mb-5 tabs-outer">
                                                            <div className="card-header position-relative py-0 details-bg">
                                                                <h2 className="card-title  m-0">Allergy Information</h2>
                                                            </div>
                                                            <div className="card-body add-new-schools p-6">
                                                                <label className="fw-bold mb-2">Allergic * </label>
                                                                <div className="d-flex">
                                                                    <label className="cursor-pointer">
                                                                        <input
                                                                            type="radio"
                                                                            id="Allergy"
                                                                            name="Allergic"
                                                                            className="form-check-input me-2 cursor-pointer"
                                                                            value="yes"
                                                                            onChange={(event) => this.inputChangeHandler(event, "student_allergy_status")}
                                                                            autoComplete="off"
                                                                        />
                                                                        Yes
                                                                    </label>
                                                                    <label className="ms-8 cursor-pointer">
                                                                        <input
                                                                            type="radio"
                                                                            id="Allergy1"
                                                                            name="Allergic"
                                                                            className="form-check-input me-2 cursor-pointer"
                                                                            value="no"
                                                                            defaultChecked
                                                                            onChange={(event) => this.inputChangeHandler(event, "student_allergy_status")}
                                                                            autoComplete="off"
                                                                        />
                                                                        No
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {this.state.allergy_data.map((index, i) => {
                                                                return (
                                                                    add_student_form.student_allergy_status.value === "yes" ?

                                                                        <div className="col-lg-12 fv-row mb-5" key={index.id}>
                                                                            {/* <label className="fw-bold mb-2">Allergic *</label> */}
                                                                            <div className="row"  >
                                                                                <div className="col-sm-3">
                                                                                    <input
                                                                                        // type={add_student_form.allergy_data[0]?.allergy_name.type}
                                                                                        value={index.allergy_name}
                                                                                        name="fname"
                                                                                        className="form-control"
                                                                                        placeholder="Allergy Name"
                                                                                        // onChange={(event) => this.inputChangeAllergyName(event, index.id, i)}
                                                                                        onChange={(event) => {

                                                                                            // Capitalize the first letter of the input
                                                                                            const value = event.target.value;
                                                                                            const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                            this.inputChangeAllergyName(
                                                                                                { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                                index.id, i
                                                                                            );
                                                                                        }}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-4">
                                                                                    <input
                                                                                        // type={add_student_form.allergy_data[0]?.allergy_info.type}
                                                                                        name="fname"
                                                                                        value={index.allergy_info}
                                                                                        className="form-control"
                                                                                        placeholder="More Info"
                                                                                        // onChange={(event) => this.inputChangeAllergyInfo(event, index.id, i)}
                                                                                        onChange={(event) => {

                                                                                            // Capitalize the first letter of the input
                                                                                            const value = event.target.value;
                                                                                            const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
                                                                                            this.inputChangeAllergyInfo(
                                                                                                { ...event, target: { ...event.target, value: capitalizedValue } },
                                                                                                index.id, i
                                                                                            );
                                                                                        }}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-sm-1">
                                                                                    <div className="d-flex justify-content-around flex-shrink-0">
                                                                                        <span
                                                                                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm pointer"
                                                                                            data-bs-toggle="tooltip"
                                                                                            title="Add"
                                                                                            data-bs-original-title="Add"
                                                                                            aria-describedby="tooltip230873"

                                                                                        >
                                                                                            <span className="svg-icon svg-icon-3 pointer" onClick={(i) => this.clickAddAllergyrow(index.id)}>
                                                                                                <i className="fas fa-plus"></i>
                                                                                            </span>
                                                                                        </span>

                                                                                        <span className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                                                                            data-bs-toggle="tooltip" title="Delete" data-bs-original-title="Delete">
                                                                                            <span className="svg-icon svg-icon-3" key={index.id} onClick={(e) => this.clickDeleteAllergyrow(index, e)}>
                                                                                                <i className="far fa-trash-alt"></i>
                                                                                            </span>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>


                                                                        </div>
                                                                        :
                                                                        null
                                                                )
                                                            })
                                                            }
                                                        </div>

                                                        <div className="col-sm-12 d-flex justify-content-end">
                                                            <div className="d-flex align-items-end">
                                                                <button
                                                                    onClick={this.SubmitHandler}
                                                                    type="submit"
                                                                    className="btn btn-sm btn-primary apply-btn min-150px"
                                                                    disabled={this.state.isLoading}
                                                                >
                                                                    Add Student
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        // error: state.students.error,
        // loader: state.students.loader,
        // isAuthenticated: state.students.isAuthenticated,
    };
}
const mapDispatchToProps = {

    onGetAllDormitoryStudent: userActions.GetAllDormitoryStudent,
    onGetAllClassesList: userActions.GetAllClassesList,
    // onGetAllSelectedCountries: userActions.GetAllSelectedCountries,
    onGetAllCountries: () => userActions.GetAllCountries(), // Wrap in a function


    onGetParentDetailsByFatherEmail: userActions.GetParentDetailsByFatherEmail,
    onGetParentDetailsByMotherEmail: userActions.GetParentDetailsByMotherEmail,

    onGetStudentHostByHostEmail: userActions.GetStudentHostByHostEmail,
    onGetStudentHostByHostContact: userActions.GetStudentHostByHostContact,

    onCreateStudentAndParents: userActions.CreateStudentAndParents,
    onGetLoginUserPermissions: userActions.GetLoginUserPermissions,



    onGetAllStatesByCountryId: userActions.GetAllStatesByCountryId,
    onGetAllCitiesByStateId: userActions.GetAllCitiesByStateId,
};
export default connect(mapStateToProps, mapDispatchToProps)(AddStudent);